export default () => {
  var brands = {
    CB: {
      bankName: 'Clydesdale',
      bankCode: 'CB',
      bankWebsite: 'http://www.cbonline.co.uk',
      phoneNumber: '0800 028 3632',
      appendBank: true,
      faqsLink:
        'https://secure.cbonline.co.uk/help-support/current-account-help/',
      faqsSavingsLink:
        'https://secure.cbonline.co.uk/help-support/savings-help/',
      monetiseLink:
        'http://www.cbonline.co.uk/personal/current-accounts/nextsteps/',
    },
    DYB: {
      bankName: 'B',
      bankCode: 'B',
      bankWebsite: 'http://www.cbonline.co.uk',
      phoneNumber: '0800 678 3654',
      appendBank: true,
    },
    YB: {
      bankName: 'Yorkshire',
      bankCode: 'YB',
      bankWebsite: 'http://www.ybonline.co.uk',
      phoneNumber: '0800 028 3632',
      appendBank: false,
      faqsLink:
        'https://secure.ybonline.co.uk/help-support/current-account-help/',
      faqsSavingsLink:
        'https://secure.ybonline.co.uk/help-support/savings-help/',
      monetiseLink:
        'http://www.ybonline.co.uk/personal/current-accounts/nextsteps/',
    },
  };

  var appLinks = {
    ios: {
      link: 'http://itunes.apple.com/app/id1051351437',
      title: 'App Store',
    },
    android: {
      link: 'https://play.google.com/store/apps/details?id=co.uk.youandb.android.b',
      title: 'Google Play',
    },
    amazon: {
      link: 'http://www.amazon.co.uk/gp/mas/dl/android?p=co.uk.youandb.android.b',
      title: 'Amazon App Store',
    },
  };

  var brand = brands.CB;

  var result = {
    bankNames: {
      CB: brands.CB.bankName,
      YB: brands.YB.bankName,
      DYB: brands.DYB.bankName,
    },
    appLinks: appLinks,
    bankWebsite: brand.bankWebsite,

    // Product Page Banner
    // bannerImageUrl: '/resources/11111111-2222-3333-4444-555555555001/NC304H_2-1_1000x500.jpg',
    // bannerStaticUrl: '/products/product-nc304/index.json',
    // bannerLink: 'http://www.cbonline.co.uk/we-care-about-here/community/countmein/',

    bannerImageUrl: '',
    bannerStaticUrl: '',
    bannerLink: '',

    exportTransaction: 'Export transactions',
    paperStatement: 'Order a paper statement',
    chequeBook: 'Order a new cheque book',
    payBook: 'Order a new pay-in book',
    typeLabel: 'Type',
    fromLabel: 'From',
    toLabel: 'To',
    debitAmountLabel: 'Debit amount',
    paymentFeesLabel: 'Payment fees',
    submissionDateLabel: 'Payment submission date',
    exchangeRateLabel: 'Exchange rate',
    actualRateLabel: 'Actual exchange rate',
    sendAmountLabel: 'Send amount',
    settlementDateLabel: 'Earliest estimated settlement date',
    referenceLabel: 'Reason for payment',
    createdByLabel: 'Created by',
    createdOnLabel: 'Created on',
    authorisedByLabel: 'Authorised by',
    feesLabel: 'Fees',
    paymentDateLabel: 'Payment date',
    bacsID: 'BACS Id',
    transactionCodeLabel: 'Transaction Code',
    hmrcReferenceLabel: 'HMRC Reference',
    referencePaymentLabel: 'Reference',
    settlementPaymentDateLabel: 'Settlement Date',

    // MasterCardAlerts
    masterCardPopupWarningHeader: 'Your changes haven’t been made yet',
    masterCardPopupWarningBody:
      'If you leave now, your changes won’t be made and your alerts won’t be updated. ',
    masterCardLeavePageBtn: 'Cancel changes',
    masterCardContinuePageBtn: 'Review and confirm changes',

    // HelpPage

    helpPageTitle: 'HelpPage',
    HelpPageHeading: 'Help',
    helpPageError: 'We were unable to load your help at this time.',
    aboutTitle: 'About Clydesdale Bank',
    aboutTitle1: 'Clydesdale Bank',
    financialServices: 'Protecting your money',
    financialServices1: 'Financial Services',
    financialServices2: ' Compensation Scheme',

    // Popup
    PopupHeading: 'Opening in new window',
    HelpModelContent:
      'This link will open in a new window or tab and will take you out of internet banking.<br></br>If you like what you see and don’t come back in 5 minutes, you’ll be automatically logged out.',
    HelpPopupContent1:
      'This link will open in a new window or tab and will take you out of internet banking.',
    HelpPopupContent2:
      'If you don’t return within 5 minutes, you’ll be automatically logged out.',

    // AnyquestionsURL

    anyQuestionURL:
      'https://secure.cbonline.co.uk/help-support/internet-banking-help/',
    anyQuestionBusinessURL:
      'https://secure.cbonline.co.uk/help-support/business-internet-banking-help/',
    prefrenceUrl:
      'https://secure.cbonline.co.uk/help-support/internet-banking-help/',

    anyQuestionURLForLimits:
      'https://secure.cbonline.co.uk/help-support/internet-banking-help/',
    // Talk Popup
    TalkHead: 'Calling the team at Clydesdale Bank',
    TalkData:
      'Call 0800 121 7 365 for free any time, day or night - from your landline or your mobile.',

    //	TalkData1: 'If you\'re calling from abroad, call +44 141 221 7300, though local providers may charge you for the call.',
    TalkData3:
      'Call <strong>0800 345 7 365</strong> free from your landline or mobile, 24 hours a day. If you’re calling from abroad, please call +44 141 951 7320.',

    TalkButton: 'Back to help',
    TalkMobileData:
      'Call <a href="tel:0800 121 7 365">0800 121 7 365</a> for free any time, day or night - from your landline or your mobile.',
    TalkMobileData1:
      'If you\'re calling from abroad, call <a href="tel:+44 141 221 7300">+44 141 221 7300</a>, though local providers may charge you for the call.',
    TalkHeader: 'Call us',
    // Email

    EmailHeader: 'Let us know what you think',
    EmailContent:
      'Let us know what you think of CB Web by sending us an email with your feedback. Before you do so, please remember never to send your bank details in an email.',
    //	EmailContent2: 'Email\’s mainly used for feedback, so if you need an answer right away, check out the FAQs or give the team at B a call.',

    EmailFooter: '(Never email your bank details.)',
    EmailHead: 'Email is just for feedback right now',
    HelpEmailHead:
      "If you'd like to email what you think of things so far please do. Your thoughts could help make Clydesdale Bank even better. Just remember, never give your bank details by email.",
    EmailBody:
      'If you need a response, check out Any questions? in Help.<br/> Or, give the team at Clydesdale Bank a call on 0800 121 7 365.',
    EmailButton1: 'Go back to Help',

    EmailButton2: 'Send feedback',

    FeedbackEmail: 'General Enquiries/NSL/NAG_EUROPE',
    EmailSubjectLine: 'My Feedback',
    EmailBody1:
      'If you need a response, check out Any questions? in Help.<br/> Or, give the team at B a call on  <a href="tel:0800 121 7 365">0800 121 7 365</a>.',

    // Feedback
    feedbackHeader: 'Let us know what you think',
    feedbackContent:
      'Share your thoughts on internet banking by sending us an email with your feedback. Before you do so, please remember never to send your bank details in an email.',
    sendFeedback: 'Send feedback',

    // Your Support
    yourSupportHeader: 'Your Support',
    yourSupportContent:
      "If you're experiencing something that affects how you bank with us, we can support you, whether it be temporary or long-term health concerns, accessibility needs or money worries.",

    // Lost cards
    LostCardHeader: 'Report a card lost or stolen',
    LostCardContentBusiness:
      '<p>Contact us as soon as you can on <strong>0800 345 7365</strong>. If you’re calling from abroad, please call <strong>+44 141 951 7320</strong>.</p>For more information, please visit our ',
    LostCardContent:
      '<p>Contact us as soon as you can on <strong>0800 345 7 365</strong>. If you’re calling from abroad, please call <strong>+44 141 951 7320</strong>.</p>For more information, please visit our ',

    LostCardContentFaq: 'FAQs',
    LostCardContentDot: '.',

    // inline error messages for move money
    nameErrorMessage: 'Please enter the payee’s name.',
    inlineErrorDangerClass: 'c-field__message alert alert-danger',
    personCompanyErrorMessage:
      'Please enter the name of the person or company you want to add.',
    referenceErrorMessage: 'Please enter a reference for this payee.',
    accountHolderErrorMessage:
      'Enter the name of the person who holds this account.',
    referenceErrorMsgMoveMoney: 'Please enter a reference for this payment.',
    nicknameErrorMessage: 'Please enter a nickname for this payee.',

    sortCodeErrorMessage: 'Please enter their six-digit sort code.',
    accountNumberErrorMessage: 'Please enter their eight-digit account number.',
    dateErrorMesaage:
      'Please select the date you want to start moving this money. This should be in the format DD/MM/YYYY.',
    accountTypeErrorMessage: 'Please select Person or Business',
    reviewHeaderMsg:
      'Please confirm the details you’ve entered are correct before you continue.',

    paymentType: 'Transaction type',
    balanceMsg: 'Balance after transaction',

    noOfPayments: 'times',
    noOfPayment: 'time',

    // Need to update in other content files
    noOfTimesEdgeCaseMessage:
      'Sorry, this exceeds the amount of repeating transactions you can set up. Please enter 300 or less then try again.',
    howOftenErrorMessage: 'Please select one of the options.',

    // company button name
    companyButtonName: 'Add payee',
    makePaymentBtn: 'Now make a payment to them',
    goAcctBtn: 'Go to your accounts',
    goMangePayeeBtn: 'Manage your payees',

    companyAddedMsg1:
      ' has now been added to your list of people and companies you pay.',
    companyAddedMsg2: 'list of people and companies you pay.',
    paymentBtn: 'Move money',
    transferBtn: 'Move money',
    btnTextPaymentPopup: 'transaction',
    btnTextTansferPopup: 'transaction',
    leaveModalSecondaryButtonText: 'Leave page',
    leaveMoveMoneyPrimaryButtonText: 'Continue with {paymentType}',
    leaveMoveMoneyBodyText:
      "If you leave this page now, your transaction won't be completed.",
    duplicatePayeeErrrmsg:
      'It looks like you’ve added these payment details before. Check the details you’ve entered and try again or choose this person or company from the list of who you pay.',
    IncorrectFormatPayeeErrorMsg:
      'Something is wrong with the format of the information in your entry. Please check your use of special characters in the Beneficiary Name, Address or Reference Fields.',

    quikLinkMsg: 'Manage your payees',
    payeeHeader: 'Add new payee',
    summaryHeaderTitle: 'New payee added',
    subHeader: 'Who would you like to pay?',
    referenceFieldMsgMoveMoney:
      'Add a brief description of what the payment is for, like ‘holiday’ or ‘dinner’. If you’re paying a company or organisation, enter the reference they’ve provided.This can usually be found on your bill or invoice.',
    referenceFieldMsgMoveMoneyTransfer:
      'Add a brief description to remind you why you moved this money. This will appear in your transactions and statements.',
    reviewHeaderTitleMoveMoney: 'Review',

    softTokenAlternativeHeaderTitleMoveMoney: 'Authorise this payment',
    softTokenAlternativeHeaderMsg:
      'To continue with this payment, you’ll have to authorise it using one of our online security methods – or go back and reduce the amount you’re trying to move.',
    noOfTimesMsg:
      'Please enter the number of times you want to move this money before it stops.',

    editpayeeSumamaryMsg: 'Payee updated',

    editPayeeWarningPopup1:
      'The changes you’ve made will only apply for future payments to this payee. If you’re already paying them by Direct Debit or standing order, you’ll need to update those details too.',
    editPayeeWarningPopup2:
      'You can update your standing order online but if you want to change a Direct Debit, you’ll have to contact the company you’re paying to make the changes for you.',

    deletePopupHeading: 'Are you sure you want to delete this payee?',
    deletePayeePopUp1:
      'You’re about to delete the following payee. This won’t affect any scheduled payments you currently have set up for them.',
    deletePayeePopUp2:
      'If you want to cancel a payment to this payee, like a Direct Debit or standing order, you can do this by managing your ',
    deletePayeePopUp3: 'scheduled payments',
    deletePopupBtn: 'Delete payee',
    payeePoupDeleted: ' has now been deleted from your list of payees.',

    viewPaymentHeader: 'Manage your scheduled payment',

    emptyDDListMsg: "You don't have any Direct Debits.",
    emptySOListMsg: "You don't have any standing orders.",
    emptyOtherListMsg: "You don't have any other scheduled payments.",

    footerDDListMsg: 'Any new Direct Debits you set up will appear here.',
    footerSOListMsg: 'Any new standing orders you set up will appear here.',
    footerOtherListMsg:
      'Any new scheduled payments you set up will appear here.',

    activeFooter: 'Any new scheduled payments you set up will appear here.',

    alternativeText: ' enter their sort code and account number',
    alternativeCompanyText: " search using the company's name",

    siteHeaderModalTitle: 'You haven’t finished yet',

    referenceNumberTextAddPayee:
      'They’ll see this. You can add customer references, credit card or roll numbers here (if you have them).',

    addPayeeBTn: 'Add payee',

    reviewSOMsg:
      '<strong> {oftenText} </strong> starting from <strong> {startDate} </strong> and stopping <strong> {endDateLabel} </strong>',
    reviewSOMsg1:
      '<strong> {oftenText} </strong> starting from <strong> {startDate} </strong> and stopping <strong> on {endDateLabel} </strong>',

    managePageheaderTitle: 'Manage your payees',
    editPageheaderTitle: 'Edit payee',
    limitLink: 'Transaction limits',
    apply: ' apply',
    amountEdgeCaseErrorMessage:
      'Sorry, this exceeds the maximum amount of money you can move online per transaction. You can see how much you’re allowed to move by viewing our transaction limits',

    // Any Questions
    FaqDone: 'Done',
    AnyquestionTitle: 'FAQs',
    AnyquestionTitle1: 'questions?',
    anyQuestionsContent:
      'Find the information you need by browsing our list of help topics, searching for keywords or phrases or selecting from our list of popular articles.',
    anyQuestionsHeading: 'Any questions?',

    // Chat
    chat: 'Live chat',
    chatContent:
      '<p><strong>Chat with us online now.</strong></p><p>We’ll keep chat transcripts for training, legal and compliance purposes.</p>',

    // Call us
    callTitle: 'Call us',
    callContentBusiness:
      'Call 0800 121 4209 free from your landline or mobile, Monday to Friday 8am to 6pm. If you’re calling from abroad, please call +44 141 248 4855.',
    // callContent : 'Call the internet banking helpdesk on 0800 121 7365 for free any time, day or night. - from your landline or mobile.<p>If you’re calling from abroad, call +44 141 221 7300, though local providers may charge you for the call.</p>',
    callContent1:
      'Call 0800 345 7 365 free from your landline or mobile, 24 hours a day. If you’re calling from abroad, please call +44 141 951 7320.',
    callContent2:
      'If you’re currently on a call with one of our advisors, you can securely ',
    callContent3: 'share your screen',
    callContent4: ' with them to get their help.',

    // Talk Panel
    talkLine: 'Call any time, day or night.',

    // Email Panel
    emailLine:
      'Send your feedback, but if you need a response please call instead. (Never email your bank details.)',

    // FAQ Panel
    faqLine: 'Find the answers right here.',

    // Demo Panel
    demoLine: 'See how the app works.',

    // About B Panel
    aboutBLine: 'Find out what you can do.',

    // T&C Panel
    tncLine: 'Take another look at our terms and conditions if you need to.',

    // AboutBHead
    AboutBHead: 'About Clydesdale Bank',
    aboutBAccessibility1: 'You are on',
    aboutBAccessibility2: 'landing page',
    AboutBContent:
      'With roots back to our establishment in Glasgow in 1838, we have a proud history of innovation and support for Scottish industry and communities.',
    aboutB: 'About Clydesdale Bank',
    cheers: 'Cheers',
    earnInterest: 'Earn interest',
    earnInterestText: 'Current rates can be found at ',
    earnInterestLink:
      'https://www.youandb.co.uk/the-account/interest-rate-charges/',
    earnInterestLinkText:
      'www.youandb.co.uk/the-account/interest-rate-charges/',
    earnInterestData1:
      'If you have any queries please call the team at Clydesdale Bank.',
    earnInterestData2:
      '** AER stands for Annual Equivalent Rate and illustrates what the interest rate would be if interest was paid and compounded each year. Gross rate is the interest payable without taking account of any tax payable.',
    getHelp: 'Get help',
    getHelpData:
      'If you need help or are unsure about anything get in touch on ',
    trackYourSpending: 'Track your spending',
    trackYourSpendingData:
      "Use Tags to find out how much you're spending, and Budgets to plan your spending from month to month.",
    overdraftText:
      'If you need some extra wiggle room, you can apply for an overdraft. Find all the details at ',
    overdraftLink: 'https://www.youandb.co.uk/the-account/your-overdraft/',
    overdraftLinkText: 'www.youandb.co.uk/the-account/your-overdraft/',
    overdraft: 'Get an overdraft if you need one.',
    overdraftData:
      "If you need some extra wiggle room, you can apply for an overdraft. Just don't forget you'll have to pay <strong>12.50% EAR<sup>††</sup></strong> on this. With a B overdraft, you get a £25.00 buffer and a two day grace period but if you go over these a £6.00 Monthly Planned Usage Fee will kick in on top of the interest.",
    overdraftData1:
      '<sup>††</sup> EAR mean Effective Annual Rate. This covers the rate and frequency of interest charged and the way it adds up (compounds) each year.',
    useyourtimeline: 'Use your timeline',
    useyourtimelineData:
      "Your timeline brings everything together, so you can easily keep an eye on the money that's coming in and out. And it gives you handy hints and tips the more you use your account.",
    freeAlerts: 'Set up free alerts',
    freeAlertsData:
      "So you always know when your money's running low in time to avoid charges.",
    projections: 'Projections',
    projectionsData:
      'Know in advance if your balance is due to run low to help you avoid missing payments.',
    sweeps: 'Sweeps',
    sweepsData:
      'Automatically move money between accounts when your balance reaches a certain amount.',
    createSavingPots: 'Create Savings Pots',
    createSavingPotsData:
      'Ideal if you have a goal in mind – like a holiday, or a new car – Savings Pots make it simple to save for the things you really want and move money around with a few taps.',
    statements: 'Get your statements online',
    statementsData: 'View and download your statements whenever you need them.',
    AboutBButton: 'Cheers',
    AboutBTableHead: 'Representative example',
    AboutBR1C1: 'Rate of interest',
    AboutBR1C2: 'Total amount of credit',
    AboutBR1C3: 'EAR<sup>††</sup>',
    AboutBR2C1: '11.84% per annum (variable)',
    AboutBR2C2: '£1200.00',
    AboutBR2C3: '12.50% variable',
    DemoSkipButton: 'Skip',

    // Terms&Conditions
    TermsCondition: 'Terms and conditions',
    AuthorisedUserTerm: 'Authorised User Terms',
    TnCHeading: 'Terms & Conditions',
    TermsConditionPageTitle: 'Terms and conditions',
    DownloadTermsCondition: 'Download our terms and conditions',
    TCHead:
      "It's kind of boring. But here it is, if you'd like to take another look.",
    TCData: 'The terms and Conditions for the Clydesdale Bank app',
    TCData1: 'B app background',
    TCData2:
      "B is designed to be an intuitive digital banking sevice built into an app. It's available on compatible tablets and compatible mobile phones and has lots of smart tools, evolving as it learns, to help you take care of your money.",
    TCData3:
      "You will need a both a compatible tablet and a compatible mobile phone to take full advantage of all features of the B app, though other mobile phones can still be used to receive SMS alerts. B accounts can't be used for Business purposes. B can be supported by a B Current account and B Instant Savings account or any other account we agree it can be used with.",
    TCData4:
      'The B accounts and services are provided by Clydesdale Bank PLC and Yorkshire Bank (which is trading name of Clydesdale Bank PLC).',
    TCData5:
      'When we refer to the "team at B", "we", "us" and "our"; we are referring to Clydesdale Bank PLC.',
    TCButton: '<strong>Back to help</strong>',

    // Demo Page Ready? Go
    DemoReadyGo: 'Ready? Go',
    DemoDone: 'Done',

    // Demo Page
    Demo: 'Demo',
    DemoContent: '[See how key features work]',
    BImg: 'Click on the arrows to see what B can do',
    TimelineImg:
      "See what's happening in all your accounts in one place. And in real time too.",
    InsightsImg:
      "Look at the tiles on the screen for handy insights into how you're spending your money.",
    TaggingImg:
      'Most of your transactions are tagged automatically with handy labels. You can change tags around and create your own too.',
    SpendingImg:
      'Take control of your money by setting budgets and tracking your tagged spend.',
    SavingsPotsImg:
      'With Savings Pots you can put away a little or a lot, whatever works for you. Every penny gets you closer to achieving your goals.',
    PaymentsImg: 'Pay anyone and make transfers easily.',
    AlertsMessagesImg: "Set up text alerts so you're always one step ahead.",
    SweepsImg:
      "Set up Sweeps to automatically move money from your B Savings account and receive texts when you're running low.",
    ProjectionsImg:
      "Look ahead and keep track of projected earnings and commitments, and receive alerts if you're going to run low.",
    HelpImg: "If you're stuck at any point just go to Help.",

    // Protected
    BankUrl: 'http://www.cbonline.co.uk/personal/savings/compensation-scheme/',
    ProtectedTitle: 'Protecting',
    ProtectedTitle1: 'your money',
    protectedLine:
      'Find out how eligible deposits are protected by the Financial Services Compensation Scheme.',

    // Product Links
    productLinkIM540: brand.bankWebsite + '/personal/current-accounts/direct/',
    productLinkIM135:
      brand.bankWebsite + '/personal/current-accounts/current-account-plus/',
    productLinkIM125:
      brand.bankWebsite + '/personal/current-accounts/current-account-control/',
    productLinkIM800:
      brand.bankWebsite +
      '/personal/current-accounts/standard-current-account/',
    productLinkIM136: 'http://www.youandb.co.uk/getb',
    productLinkInstantSavings:
      brand.bankWebsite +
      '/personal/savings/everyday-instant-access-accounts/instant-savings-account/',
    productLinkSavingsPlus:
      brand.bankWebsite +
      '/personal/savings/everyday-instant-access-accounts/savings-account-plus/',
    productLinkSignatureSavings:
      brand.bankWebsite +
      '/personal/savings/everyday-instant-access-accounts/signature-savings-account/',

    // Document
    documentTitle: brand.bankCode + ' Web',
    navigationWarning:
      "If you refresh or leave this page, you'll lose any unsaved progress. Are you sure you want to leave?",

    // Header Logo
    headerLogoAlt: brand.bankName + ' Bank Logo',

    // AccountDetailComponent
    // Account Details
    availableBalance: 'Available balance',
    borrowingLimit: 'Planned borrowing limit',
    lastStatementDate: 'Last statement date',
    lastStatementBalance: 'Last statement balance',
    minPaymentDue: 'Minimun payment due',
    paymentDueDate: 'Payment due date',
    creditCardLimit: 'Credit card limit',
    AccountMoreInfoView_AvailableBalanceDisclaimer:
      "This balance may also include items that haven't gone through yet.",
    AccountMoreInfoView_AvailableBalanceDisclaimer_WithOverdraft:
      "This balance, which includes any overdraft, may also include items that haven't gone through yet.",
    AccountMoreInfoView_ContactMessage:
      "If you'd like to talk about this account, please call the team at B on 0800 1217365.",
    prevSlide: '◀︎',
    nextSlide: '▶︎',
    helpButton: 'Help',
    searchKey: 'Search',
    yesText: 'Yes',
    FYI: 'FYI',
    transition: 'scale',
    current: 'current',
    creditCard: 'credit_card',
    savings: 'savings',
    loan: 'loan',
    mortgage: 'mortgage',
    moreInformation: 'More Information',
    hideInformation: 'Hide Information',
    dateRangeVallidationMsg:
      'Sorry, something’s not right there. Please make sure the date you’ve entered is less than five years ago and before the date you want to view your transactions up to.',
    todateRangeVallidationMsg:
      'Sorry, something’s not right there. Please make sure the date you’ve entered isn’t in the future or before the date you want to view your transactions from.',
    chooseDateValidationMsg:
      'Choose the date range you want show. This should be entered as DD/MM/YYYY.',
    applyFilter: 'Apply Filter',

    // account view
    availableBalanceExpalanationText:
      "Your available balance includes pending transactions, so it shows what you've got available right now.",
    availableBalanceWithOverdraftExpalanationText:
      "Your available balance includes pending transactions, so it shows what you've got available right now. It also includes your overdraft if you have one.",
    HCCRavailableBalanceExpalanationText:
      "This balance shows pending transactions, including any cheques that haven't cleared yet.",
    HCCRavailableBalanceWithOverdraftExpalanationText:
      "This balance shows pending transactions, including any cheques that haven't cleared yet. You'll see your overdraft separately if you have one.",
    clearedBalanceExplanationText:
      'This is your current balance excluding any cheques that haven’t cleared yet. When a cheque clears, it’ll be included here – but it may still be returned unpaid by the bank it came from.',
    accountBalanceContactUs:
      'If you’d like to talk about this account, please contact us.',

    // Financial Stories & Projection
    Showing: 'Showing',
    Upto: 'up to',
    CurrencySign: '-£',
    transactionGridMessage:
      "That's all we can find. Try changing your date range?",
    MicroTransaction: 'microTransactions',
    Cashpoint: 'cashpoint',
    InAndOut: 'insAndOuts',
    Projection: 'projection',
    accountDetailsInprogressHeader: 'In progress',
    accountDetailsInprogressContent: 'This is still going through',
    inAndOutFootrText: 'You had {credit} come in,\nbut {only} {debit} go out.',
    inAndOut_headerTextCurrentMonth:
      "Nothing's gone in or out\nof your account so far",
    inAndOut_headerTextOtherMonths: 'Nothing went in or out\nof your account',
    inAndOut_headerTextCurrentMonthPositiveSum: "So far you're up {sum}",
    inAndOut_headerTextCurrentMonthNegativeSum: "So far you're down {sum}",
    inAndOut_headerTextOtherMonthsPositiveSum: 'You were up {sum}',
    inAndOut_headerTextOtherMonthsNegativeSum: 'You were down {sum}',
    cashpoint_headerTextCurrentMonth: "You haven't taken out\nany cash so far",
    cashpoint_headerTextOtherMonths: "You didn't take out any cash",
    cashpoint_headerTextCurrentMonthSum:
      "You've taken out {sum} in cash so far",
    cashpoint_headerTextOtherMonthsSum: 'You took out {sum} in cash',
    cashpoint_footerText: 'You usually take out {sum} at a time.',
    noTransactionMessage:
      "Sorry but it's not possible to show payments for this account type.",
    noTransactionFound: 'No transactions found',
    takeLookAtFaq: 'Take a look at our FAQs',
    transactionReTag: '{TranNo} transaction has been retagged {TagName}',
    transactionReTags: '{TranNo} transactions have been retagged {TagName}',
    transactionUnTag: '{TranNo} transaction has been untagged',
    transactionUnTags: '{TranNo} transactions have been untagged',
    transactionGridMobileMessage: "That's all we can find.",
    transactionRefundDetails:
      'The merchant has confirmed that your refund is being processed. We’ll show the refund in your balance once we’ve received it. Any questions?',
    transactionRefundFaqLink:
      'https://uk.virginmoney.com/service/debit-card-refunds/',
    transactionRefundNotInBalance:
      'This won’t show in your balance yet - find out more',
    micro_headerTextCurrentMonth:
      "So far you haven't paid\nfor anything under a tenner",
    micro_headerTextOtherMonths: "You didn't pay for\nanything under a tenner",
    micro_headerTextCurrentMonthWithSum:
      "So far you've spent {sum} on things under a tenner",
    micro_headerTextOtherMonthsWithSum:
      'You spent {sum} on things under a tenner',
    micro_footerText: "That's about {sum} a pop.",
    currency: 'GBP',
    asc: 'asc',
    desc: 'desc',
    threeMonths: '3 months',
    customRange: 'Custom Range',
    transactionListViewError:
      'We were unable to load your transactions at this time. Please try again later or pull down to try again now',

    projection404Title:
      'See in advance how the rest of your month is panning out.',
    projection404Subtitle: 'Set up Projections',

    projection409_0Title:
      "You're all set up, now B's just crunching the numbers.",
    projection409_0Subtitle: 'Calculating...',

    projection409_1Title:
      "B doesn't have enough to go on at the moment - please try again soon.",
    projection409_1Subtitle: 'Try again soon',
    projection409_1NotEnoughData: '##days## days left...',
    projection409_1NotEnoughDays: '##days##',

    projection409_2Title:
      "Your preferences have been updated, B's just crunching the numbers.",
    projection409_2Subtitle: 'Calculating...',

    projection500Title: 'There was an error retrieving your Projection',
    projection500Subtitle: 'Please try again later',

    projection200GoodTitle:
      "Great news, looks like you'll be in the green 'til payday.",
    projection200GoodSubTitle: 'Go to Projections',

    projection200BadTitle:
      "You're running low - top up to ensure your bills get paid.",
    projection200BadSubtitle: 'Review Projections',
    // Key Features
    noMonthlyFee: 'There is no monthly fee for this account.',
    noMonthlyFeeOrCharges: 'There are no fees or charges for this account.',
    monthlyFee: 'There is a monthly fee of {} for this account.',
    variableCreditInterest:
      'Variable credit interest is payable on this account on credit balances.',
    noCreditInterest: "This account doesn't pay credit interest.",
    interestUpTo3000:
      'Interest is payable on this account on credit balances up to £3000.',
    noUnplannedBorrowing:
      'Borrowing is not available on this account. Requests for unplanned borrowing will usually be declined. Full details can be found in the Borrowing section of your Terms & Conditions and in your Tariff.',
    plannedBorrowing125:
      'Planned borrowing is available on this account, subject to eligibility. The cost of this is £6 per month plus interest. Requests for unplanned borrowing will usually be declined. Full details can be found in the Borrowing section of your Terms & Conditions and in your Tariff.',
    plannedBorrowing:
      'Borrowing is available on this account, subject to eligibility, and is usually more expensive if not agreed in advance. Planned borrowing costs £6 per month plus interest. Unplanned borrowing costs £6 per day. An item returned unpaid costs £15. Full details can be found in the Borrowing section of your Terms & Conditions and in your Tariff.',
    fscsCovered:
      'Your eligible deposits with Clydesdale Bank PLC are protected up to a total of £75,000 by the Financial Services Compensation Scheme, the UK\'s deposit guarantee scheme. This limit is applied to the total of any deposits you have with Clydesdale Bank, Yorkshire Bank and B. Any total deposits you hold above the limit between these brands are unlikely to be covered. Please see <a href="http://www.cbonline.co.uk/resources/b82e172a-b00f-4783-973b-e4399da349e4/fscs_2015_online-leaflet.pdf" target="_blank">FSCS leaflet<span class="screenreader"> This link will open in a new browser window</span></a> for further information or visit <a href="http://www.fscs.org.uk" target="_blank" title="www.fscs.org.uk. This link will open in a new browser window">www.fscs.org.uk<span class="screenreader"> This link will open in a new browser window</span></a>',
    defaultCancellationPolicy:
      'You can cancel your agreement with us within 14 days of opening the account, or from the day you receive the Terms & Conditions if later, by contacting us in branch, phone or in writing. You will need to repay any debit balance, interest and fees incurred within 30 days from the date you tell us you want to cancel it.',
    savingsDefaultCancellationPolicy:
      'You can cancel your agreement with us within 14 days of opening the account, or from the day you receive the Terms & Conditions if later, by contacting us in branch, phone or in writing.',
    mortgageSaver:
      'This account is eligible for inclusion in mortgage offsetting arrangements. Any credit balance can be used to set against the debit balance on your Offset Mortgage held with us and so reduce the interest payable on your mortgage. Full details can be found in the Offsetting section of your Terms & Conditions.',
    caDirectKeyFeature:
      'This account requires a minimum deposit of £1000 per month (excluding transfers from other accounts held with us), and that you must register for telephone and internet services and use these for day-to-day banking. Please note, if you fail to meet these criteria, we may change your account to a Current Account Plus which has different interest rates.',
    caDirectKeyFeature2:
      'You can have a maximum of 2 Current Account Direct accounts, of which only one may be a sole account.',

    // Key Features B
    serviceCommitmentB:
      "We're committed to providing our customers with the best possible service from us but more information can be found in the Terms & Conditions about what to do if you have a complaint.",
    overdraftFacilityB:
      'Overdrafts are available on this account subject to eligibility. Going overdrawn is usually more expensive if not arranged in advance. Applicable fees and interest, for both planned and unplanned borrowing, can be found in your Tariff.',
    packagedAccountOpening:
      'Both a current account and a linked savings account must be opened at the same time, please see Terms & Conditions for full details.',
    creditInterestPaid:
      'Credit interest is payable on both the current account and the savings account, please refer to your Tariff for rates.',
    creditBalanceMortgage:
      'Any credit balance in this account may be used to reduce the debit interest calculated on your mortgage account with us.',
    noticeOfChanges:
      "We will usually give you two months' notice of changes, the Terms & Conditions detail any that we may make sooner.",

    downgradedOfferPageKeyFeaturesTitle: 'Key features for the',
    downgradedOfferKeyFeaturesParagraph:
      'This section contains certain key information relating to this alternative offer of a Readycash Account. Full details are contained in your terms & conditions and tariff attached below which you should read.',

    // Offer Restrictions ReadyCash
    noCheckbook: 'Chequebook facilities.',
    noMortgageOffset: 'The ability to offset against a mortgage product.',
    noLinkedSavings: 'Linked savings account.',

    // SideBar
    sideBarTitle: 'Need Help?',
    sideBarContentLine1: 'Call us on:',
    sideBarContentLine2: '0800 028 3632,',
    sideBarContentLine3: 'Monday to Friday 08:00 to 20:00.',
    sideBarContentLine4: 'Saturday 09:00 to 17:00.',
    sideBarContentLine5: 'Closed on Sunday.',

    // Footer
    footerLinkText1: 'Footer Link 1',
    footerLinkUrl1: '/',
    footerLinkText2: 'Footer Link 2',
    footerLinkUrl2: '/',
    footerLinkText3: 'Footer Link 3',
    footerLinkUrl3: '/',
    footerLinkText4: 'Footer Link 4',
    footerLinkUrl4: '/',

    // Landing Page
    landingPagePageHeader: 'CB Web',
    landingPageTitle: "You're applying for a ",
    landingPageIntro:
      "We've tried to keep this online application straightforward. It includes everything you need to apply and open an account with a debit card. Please be aware our online application does not currently offer the ability to arrange an overdraft. <strong>If you require an overdraft and are planning to use the Current Account Switch Service, please call us or go into a branch.</strong>",
    'landingPageIntro-savings':
      "We've tried to keep this online application straightforward. It includes everything you need to apply and open an account.",
    landingPageQuestionsNote:
      'If you think there are special circumstances (e.g. you are vulnerable or experiencing financial difficulties) then Readycash is our Basic Banking Account may suit your needs better than one of our other accounts. If you think there are special circumstances related to your application, please call us on 0800 028 3632 or call into one of our branches.',
    'landingPageQuestionsNote-savings': '',
    existingCustomerTitle: 'Existing customer?',
    initialQuestionsTitle: 'Initial questions',
    initialQuestionsSubtitle: undefined,
    infoToApplyTitle: 'To apply',
    infoToApplyIntro: "You'll need these handy:",
    infoToApply1: 'Your addresses for the past 3 years',
    infoToApply2:
      'The name of your employer, how much you get paid and when you started work',
    'infoToApply2-savings':
      'The name of your employer and when you started work',
    infoToApply3: 'How much you usually spend each month',
    'infoToApply3-savings': '',
    infoToApply4: '',
    infoToApply5: '',
    isExistingCustomer:
      'Have you ever held an account with ' + brand.bankName + ' Bank?',
    isExistingCustomerHelpMessage:
      'Even if you held this account in the past, please select Yes.',
    isExistingCustomerValidationMessage:
      "Sorry, you can't apply online, so please call us instead and apply over the phone. Or, if you prefer, go into a branch and ask for help there.",

    // Eligibility Questions
    eligibilityAge18Question: 'Are you 18 or over?',
    eligibilityAge18QuestionValidationMessage:
      "As you're under 18 you can't apply online, so please call us or, if you prefer, go into a branch and ask for help there.",
    eligibilityAge18QuestionHelpMessage:
      "If you're aged between 16-17, you might be able to have an account, but we need additional information first. Please call us or go to a branch and ask for help.",
    eligibilityAge16Question: 'Are you 16 or over?',
    eligibilityAge16QuestionValidationMessage:
      'Sorry, but if you\'re under 16 we can\'t offer you this account at the moment. But we do have some other products that might be of interest. Click on the link to find out more: <a href="javascript:void(0)">CA Plus</a> &amp; <a href="javascript:void(0)">Jumpstart</a>',
    eligibilityAge16QuestionHelpMessage:
      'You need to be 16 or over to have a bank account.',
    eligibilityUKResidentQuestion: 'Are you a UK resident?',
    eligibilityUKResidentQuestionValidationMessage:
      "We need to ask you a few questions we can't cover online. Can you please call us and we'll explain what's involved.",
    eligibilityUKResidentQuestionHelpMessage:
      'You can answer Yes if you are a UK resident, even if you were born in another country or you used to live abroad.',
    eligibilityDeviceQuestion:
      'Do you have or plan on having a compatible device to use the DYB proposition?',
    eligibilityDeviceQuestionValidationMessage:
      'You can not proceed with the application if you do not have a compatible device to use the DYB proposition and links to other products I might be eligible for.',
    eligibilityDeviceQuestionHelpMessage:
      'For details of the operating systems and example mobile and tablet devices supported by the B app, please visit: <a href="http://www.youandb.co.uk/devices" target="_blank" title="www.youandb.co.uk/devices. This link will open in a new browser window">www.youandb.co.uk/devices <span class="screenreader">This link will open in a new browser window</span></a>.',

    // Terms & Conditions
    eligibilityTermsTitle: 'Use of Personal Information',
    eligibilityTerms1:
      "The information you provide will be used to assess your application, and to set up and manage your account. Where you've given us information about any other people as part of an application for a joint account, you also confirm that each person has authorised you to do so as part of the application.",
    eligibilityTerms2:
      'A full description of how and for what purposes your information may be processed <a href="static/DU1950.pdf" target="_blank" title="Download Personal Information Statement PDF. This link will open in a new browser window" aria-label="Download Personal Information Statement PDF. This link will open in a new browser window.">can be viewed here <span class="screenreader">Download Personal Information Statement PDF. This link will open in a new browser window</span></a>.',
    eligibilityTerms3:
      'We will share your information with Credit Reference Agencies to help determine what credit products and services we can provide you. These agencies will use the information for assessing credit applications, debt tracing and prevention of money laundering. In the case of joint applications, you confirm all applicants understand that an association linking their financial records together will be created by these agencies.',
    'eligibilityTerms3-savings':
      'In order to prevent or detect fraud, the information provided in applications will be shared with fraud prevention agencies. If false or inaccurate information is provided by you or on your behalf, if we suspect fraud or if fraud is identified, details will be kept in our records and also passed to fraud prevention agencies, law enforcement agencies and other organisations involved in crime and fraud prevention which may access and use this information.',
    eligibilityTerms4:
      'If false or inaccurate information is provided and fraud is identified, details will be passed to fraud prevention agencies to prevent fraud and money laundering. Further details explaining how the information is held by fraud prevention agencies can be found in our Use of Personal Information documentation.',
    'eligibilityTerms4-savings': '',
    eligibilityTermsClosingText:
      'Please read and save a copy of the Use of Personal Information Statement for your reference and records. This will also be emailed to you.',
    acceptTsAndCs: 'I agree to the use of personal information above.',
    dataProtectionDocDownloadLabel: 'Download as PDF',
    dataProtectionDocLink: 'static/DU1950.pdf',
    dataProtectionDocLinkTitle:
      'Download Personal Information Statement PDF. This link will open in a new browser window.',
    dataProtectionDocFileName: 'DU1950.pdf',
    dataProtectionDocVersion: 'I',

    // Step 1 - Your Details
    personalDetailsPageHeader: 'Personal details',
    personalDetailsTitle: 'Personal details',
    personalDetailsGuidance:
      'If you need to make any changes to your personal details please call our team on ' +
      brand.phoneNumber,
    personalDetailsSubtitle: undefined,

    titleQuestion: 'Title',
    titleHelpMessage: 'Please select from the given list.',
    firstNameQuestion: 'First Name',
    firstNameValidationMessage:
      'Sorry, your name must be made up of letters and spaces only.',
    firstNameHelpMessage: 'Your first name, as shown on your passport.',
    hasMiddleNameQuestion: 'Do you have a middle name?',
    hasMiddleNameHelpMessage: 'Your middle name, as shown on your passport.',
    middleNameValidationMessage:
      'Sorry, your name must be made up of letters and spaces only.',
    middleNameQuestion: 'Middle Name',
    lastNameQuestion: 'Last Name',
    lastNameValidationMessage:
      'Sorry, your name must be made up of letters and spaces only.',
    lastNameHelpMessage:
      "Your last name, as shown on your passport. If your name has changed, for example because of marriage, make sure you use the name that you're officially registered with.",
    dateOfBirthQuestion: 'Date of birth',
    dateOfBirthValidationMessage:
      'You need to be at least 18 years old to be eligible for this account.',
    dateOfBirthHelpMessage:
      'You need to be at least 18 years old to open an account online so please call us or, if you prefer, visit your local branch and ask for help there.',
    genderQuestion: 'Gender',
    genderHelpMessage:
      'We need this so we can check your information using our decision processes.',
    genderValidationMessage:
      'Please confirm if your title and gender are both correct on ' +
      brand.phoneNumber,
    maritalStatusQuestion: 'Marital status',
    maritalStatusHelpMessage:
      'We need this so we can check your information using our decision processes.',
    hasDependantsQuestion: 'Do you have any dependants?',
    hasDependantsHelpMessage:
      'A legal dependant includes anyone you have a legal duty to support, such as children.',
    personalDetailsFoundValidationMessage:
      'It appears you are already a customer. <a href="/account-opening/authentication?applyFor={productCode}">Please login to continue</a>.',

    // Step 1 - Addresses
    addressTitle: 'Current address',
    addressSubtitle:
      "We'll need the addresses for everywhere you've lived for the past 3 years.",
    addressLookupError:
      'We were unable to look up your postcode. Please try again or contact us to proceed.',
    addressNoExactMatch: "Don't see your exact address? Contact us to proceed.",
    previousAddressTitle: 'Previous address',
    previousAddressSubtitle:
      "We need to know where you've been living for the last 3 years.",
    residentialStatusHelpMessage:
      'Choose the option which best describes your status while living at this address. If you have a mortgage and live there, select Owner.',
    residentialStatusValidationMessage:
      'Please select an option from the dropdown list.',
    livedForThreeYearsQuestion:
      'Please confirm that you have lived at the address shown above for at least 3 years.',
    livedForThreeYearsValidationMessage:
      'Please contact the bank on 0800 028 3632 to update your address history.',
    residentialStatusQuestion: 'Residential status',
    dateMovedQuestion: 'Date moved to address',
    removeAddressButtonLabel: 'Remove Address',
    postcodeSearchButtonLabel: 'Find address',
    postcodeSearchLegend: 'Postcode',
    selectAddressPlaceholder: 'Please select your address...',
    selectAddressLabel: 'Select your address',
    selectAddressSelectButtonText: 'Select',
    addressesQuestion: 'Postcode',
    postcodeQuestion: 'Postcode',
    addressTypeQuestion: 'Did you live in the UK?',
    addressInvalidMessage:
      "Something isn't right with your postcode, please contact the team at " +
      brand.bankName +
      ' on ' +
      brand.phoneNumber,

    // Step 1 - Contact Details
    contactDetailsTitle: 'Contact details',
    contactDetailsIntro:
      'Your phone number and email address will be used to complete your application and to help us look after your account in the future.',
    phoneNumberQuestion:
      'Mobile number (Helps you access and manage your online account).',
    phoneNumberValidationMessage:
      'Your phone number should be 11 characters long and include numbers only, no spaces or symbols. A mobile number is needed to access internet and phone banking.',
    phoneNumberHelpMessage:
      "You can use a landline number if you want, however a mobile number is required at this point if you want to register for internet and telephone banking as part of this application. If you don't want to be contacted by mobile, you can tell us below.",
    emailAddressQuestion: 'Email address',
    emailAddressValidationMessage:
      "Please check your email address? It needs to include a '@' and a '.' to be formatted the right way.",
    emailAddressHelpMessage:
      "If you don't want to be contacted by email, you can tell us below.",
    emailAddressConfirmationQuestion: 'Confirm email address',
    emailAddressConfirmationValidationMessage:
      "Your email addresses don't match. Can you check them please?",
    emailAddressConfirmationHelpMessage:
      'Please ensure this is the same as you have entered above.',
    contactMethodTitle: 'Preferred contact method',
    contactMethodIntro:
      "We'll try to use your preferred contact method where possible. However for any issues relating to account security, we'll always give you a call. Once you've finished your application, we'll email you all the related documents. Everything else, including statements, we'll post to you.",
    preferredContactMethodQuestion: "I'd prefer to be contacted by",
    contactMethodsValidationMessage:
      'Please select at least one contact method.',

    // Step 1 - Select Your Bank
    selectBankTitle: 'Select Your Bank',
    selectBankQuestion: 'Which bank is handy for you?',
    selectBankSubtitle:
      'B Bank is powered by Clydesdale Bank and Yorkshire Bank. For branch offering purposes, if you live in England, Yorkshire Bank has the most branches. If you are based in Scotland go for Clydesdale Bank. There is a Clydesdale Bank branch and a Yorkshire Bank branch in central London.',
    bankIDHelpMessage:
      "Please select one of the banks, which seems the best fit for your location. Please call us if you're not sure.",
    bankIDValidationMessage: 'This is required.',

    selectBankHelpLink: 'http://www.cbonline.co.uk',
    selectBankHelpLinkText: 'Click here for more Information',

    selectBankHelpLinkCb: 'http://www.cbonline.co.uk/personal/online-locator/',
    selectBankHelpLinkCbText: 'Clydesdale Bank Branch Locator',
    selectBankHelpLinkCbTitle:
      'Clydesdale Bank Branch Locator link. This link will open in a new browser window',
    selectBankHelpLinkYb: 'http://www.ybonline.co.uk/personal/online-locator/',
    selectBankHelpLinkYbText: 'Yorkshire Bank Branch Locator',
    selectBankHelpLinkYbTitle:
      'Yorkshire Bank Branch Locator link. This link will open in a new browser window',

    // Step 1 - Username and Password
    setPasswordTitle: 'Username and password',
    usernameInfo:
      "Once you've created your username and password, your application will be saved. If you need to retrieve your application to complete it or to view an online decision, you will be able to log in through the Retrieve application link on the website. Please take care in choosing your password, and keep it safe, as you'll need it later to log in to internet banking and we won't be able to remind you of it. Your username must be 6-16 characters in length, using only letters and numbers. Your password must be 8-12 characters long, including at least one letter and one number. It is also case sensitive.",
    unsavedUsernameHelpMessage:
      'Your username must be 6-16 characters in length, using only letters and numbers. Please note it is also case sensitive.',
    unsavedUsernameValidationMessage:
      'Your username must be 6-16 characters in length, using only letters and numbers. Please note it is also case sensitive.',
    usernameAlreadyInUseValidationMessage:
      'Your username needs to be unique. Someone has taken that one already, so please choose another one.',
    password1Question: 'Password',
    password2Question: 'Password (confirm)',
    passwordRequirements:
      "Your password should be 8-16 characters long with at least one letter, number and symbol. It's case sensitive too.",
    password1HelpMessage:
      "Your password should be 8-16 characters long with at least one letter, number and symbol. It's case sensitive too.",
    password1ValidationMessage:
      "It needs to be tougher than that. Your password should be 8-16 characters long with at least one letter, number and symbol. It's case sensitive too.",
    password2HelpMessage:
      "Your password should be 8-16 characters long with at least one letter, number and symbol. It's case sensitive too.",
    password2ValidationMessage:
      "Oops. Your passwords don't match. Please have another go.",
    passwordDisclaimer:
      'You can save and retrieve your account at a later date, you can use the same password to login. This password will also be the one you use to enrol for online and mobile banking.',

    // Employment Details
    employmentDetailsHeader: 'Employment details',
    employmentDetailsTitle: 'Employment details',
    employmentSectionTitle: 'Employment details',
    employmentSectionSubtitle: undefined,
    employmentSectionIntro:
      "Please tell us about your job and income. You'll need to know when your job started and the name of your employer.",

    employmentStatusQuestion: 'Employment status',
    employmentStatusHelpMessage:
      'Pick the option that suits your current situation at the time of making this application.',
    employmentOccupationHelpMessage:
      'Please select the category that closest fits your job description.',
    employmentStartDateQuestion: 'Employment Start Date',
    employmentStartDateValidationMessage:
      'Sorry, your employment date doesn’t seem right. Try again?',
    employmentStartDateHelpMessage:
      'This should be the date of your first paid day of work in your current job.',
    employerNameValidationMessage:
      "Please fill in your employer's name as it appears on your payslip",
    employerNameHelpMessage:
      'This should be the same as it appears on your payslip',

    // Employment Details - Nationality
    nationalityTitle: 'Nationality',
    nationalityQuestion: 'Nationality',
    nationalityHelpMessage: 'Please select your country of nationality.',
    cityBorn: 'City or town where you were born',
    cityBornValidationMessage:
      'Your place of birth must be made up of letters and spaces only.',
    cityBornHelpMessage: 'As it appears on your birth certificate or passport.',
    countryBorn: 'Where you were born',
    countryBornHelpMessage: 'As stated on your birth certificate.',
    ukCitizen: 'Are you a UK citizen?',
    ukCitizenValidationMessage:
      'You must be a UK citizen in order to open an account.',
    ukCitizenHelpMessage:
      "Select 'Yes' if you have a UK passport or are eligible for one.",
    hasAdditionalCitizenships: 'Do you have any other citizenships?',
    hasAdditionalCitizenshipsValidationMessage:
      "If you're not a UK citizen, please tell us where you're from.",
    hasAdditionalCitizenshipsHelpMessage:
      "If you're a legally registered citizen of any other countries, you need to list them here.",
    citizenshipListQuestion: 'What country or countries?',
    citizenshipListValidationMessage:
      "Please select a country from each of the additional citizenship options you've selected.",

    // Employment Details - Tax
    taxObligationsTitle: 'Tax',
    hasNoTaxOligations: 'Are you a UK tax resident only?',
    hasNoTaxOligationsHelpMessage:
      'Choose "no" if you are not a UK tax resident OR if you have tax obligations in any country in addition to the UK.',
    taxCountryHelpMessage:
      'Which country(ies) do you have a tax obligation in? Please ensure you include details of all countries of tax residency, including the UK.',
    taxNumberHelpMessage:
      'This is a code or number that is associated with your tax obligation, usually issued by the tax authority of your country of tax residence. It is mandatory that, if your country of tax residency does issue a tax ID number or equivalent, you must provide this for the country entered. If you do not know what this is, or do not have a tax ID for other reasons,  please call us.',
    allTaxObligationsListed:
      'I hereby confirm I have no tax obligations other than in the countries listed above.',
    allTaxObligationsListedValidationMessage:
      'Please list all your tax obligations.',
    allTaxObligationsListedHelpMessage:
      "If you've got a tax obligation that doesn't fit these options, please call us.",
    taxObligationListValidationMessage:
      'Please add in the detail for each of your additional tax obligations.',
    taxNumberNA: 'Country of Tax Residency does not issue a Tax ID number',
    taxNumberMissing: 'I do not have my Tax ID Number here',
    taxObligationsListCountryFieldName: 'Country of tax residency',
    taxObligationsListHasTaxNumberFieldName:
      'Does your country of tax residency issue a tax ID number?',
    taxObligationsListTaxNumberName: 'Tax ID',
    taxNumber0ValidationMessage:
      'Letters and numbers only (no symbols or punctuation)',
    taxNumber1ValidationMessage:
      'Letters and numbers only (no symbols or punctuation)',
    taxNumber2ValidationMessage:
      'Letters and numbers only (no symbols or punctuation)',
    taxNumber3ValidationMessage:
      'Letters and numbers only (no symbols or punctuation)',
    taxNumber4ValidationMessage:
      'Letters and numbers only (no symbols or punctuation)',

    // Employment Details- Income
    incomeSectionTitle: 'Your income',
    grossAnnualIncome: 'Your annual income before tax',
    grossAnnualIncomeValidationMessage:
      'Put in a whole number please, without spaces or commas. For example 30000.',
    grossAnnualIncomeHelpMessage:
      'If you are working, please enter your annual salary before tax. Otherwise please enter zero.',
    netMonthlyIncome: 'Your monthly income after tax.',
    incomeSectionCurrentAccountSubtitle: 'Current Account Details',
    incomeSectionSavingsAccountSubtitle: 'Savings Account Details',
    netMonthlyIncomeValidationMessage:
      'Please enter whole numbers, without spaces or commas. Your monthly income shouldn’t be more than your annual income divided by 12.',
    netMonthlyIncomeHelpMessage:
      'This is the amount you receive each month after tax and deductions. You can include the following incomes: salary, pensions and state benefits (such as disability living allowance, personal independence payment, carers allowance, reduced earnings allowance).',
    hasAdditionalIncome: 'Do you have any other sources of income?',
    hasAdditionalIncomeValidationMessage: 'Please select an answer.',
    hasAdditionalIncomeHelpMessage:
      "You might get rent in from somewhere or have a second job, or maybe you get interest from investments? If it's something that you declare on your tax returns, you should add it here.",
    incomeOtherAmount: 'How much extra income do you get per year?',
    incomeOtherAmountValidationMessage:
      'Put in a whole number please, without spaces or commas. For example 5000.',
    incomeOtherAmountHelpMessage:
      'Please tell us the overall figure for your other sources of income. If this is hard to calculate, just add in a realistic amount that you know is a guaranteed amount you can prove. If you’d like some help please call us.',
    incomeOtherFrequency: 'That money tends to come in',
    incomeOtherFrequencyOptionsHelpMessage:
      "It's possible that income might come unpredictably or at different times. If there is an option that makes sense for the majority of your payments, please choose it. Otherwise, please call us.",

    incomeOtherSavingsAmount:
      'How much are you planning on paying into your savings account?',
    incomeOtherSavingsAmountValidationMessage:
      'Put in a whole number please, without spaces or commas. For example 5000.',
    incomeOtherSavingsAmountHelpMessage:
      "Tell us an overall amount you hope to save annually. If you're not sure, add in a realistic number, perhaps based on previous savings habits.",
    incomeOtherSavingsFrequency:
      'How often are you planning to pay savings in?',
    incomeOtherSavingsFrequencyHelpMessage:
      "If you're not sure how often you'll be paying in, pick an option that is likely to be one that makes most sense. If you're not sure what to put, please call us.",
    incomeOtherSavingsTypeOptions: 'What will you pay into this account?',
    incomeOtherSavingsTypeOptionsHelpMessage:
      'Choose the option that feels the most relevant one to you.',
    incomeOtherSavingsPurpose:
      "What's your main reason for opening this account?",
    incomeOtherSavingsPurposeHelpMessage:
      'Please select the main reason for having this account. If there are a few reasons there that make sense to you, just pick one you know is important.',

    incomeOtherPaymentAmount: 'How much will you pay in each month?',
    incomeOtherPaymentAmountValidationMessage:
      'Put in a whole number please, without spaces or commas. For example 3000.',
    incomeOtherPaymentAmountHelpMessage:
      'This is an overall monthly figure which indicates how much income you plan to pay into your new account.',
    incomeOtherAccountPurpose:
      "What's your main reason for opening this account?",
    incomeOtherAccountPurposeHelpMessage:
      'Please select the main reason for having this account. If there are a few reasons there that make sense to you, just pick one you know is important.',
    incomeOtherAccountPurposeValidationMessage: 'Please select an answer.',
    incomeOtherPaymentType: 'What will you pay into this account?',
    incomeOtherPaymentTypeOptionsHelpMessage:
      'Choose the option that feels the most relevant one to you. This should incorporate all your income sources.',
    incomeOtherPaymentTypeOptionsValidationMessage:
      'Please select one of the options.',

    // Employment Details - Expenses
    expenditureSectionTitle: 'Your monthly expenditure',
    mortgageOrRentExpenditure: 'Mortgage/Rent expenditure',
    mortgageOrRentExpenditureValidationMessage:
      'Put in a whole number please, without spaces or commas. For example 1500.',
    mortgageOrRentExpenditureHelpMessage:
      'This is the monthly figure for your rent or mortgage.',
    expenditureOther: 'Other credit payments',
    expenditureOtherValidationMessage:
      'Put in a whole number please, without spaces or commas. For example 2000.',
    expenditureOtherHelpMessage:
      'The amount you enter here should be the total monthly amount you pay on any personal loans, credit cards and hire purchase agreements.',

    // Review Page
    reviewPageHeader: 'Review',
    reviewTopTitle: 'Review and submit your application',
    reviewTopSubtitle: "Great, you've finished",
    reviewTopParagraph:
      "Please review what you've told us and if necessary edit any of the information you've provided. Please ensure you read all the important information including key features, terms & conditions and tariff.  When you're ready, submit. We'll take care of the rest.",
    reviewPageTitle: 'Review and submit your application',

    reviewPersonalDetailsTitle: 'Your details',
    reviewSectionPersonalTitle: 'Personal details',
    reviewSectionContactTitle: 'Contact details',
    reviewSectionNationalityTitle: 'Nationality',
    reviewEmploymentDetailsTitle: 'Employment details',
    reviewSectionEmploymentTitle: 'Employment details',
    reviewSectionIncomeTitle: 'Income',
    reviewSectionOutgoingsTitle: 'Expenditure',
    reviewTermsDocumentsTitle: 'Documents for you to read and save',
    reviewTermsDocumentsParagraph:
      'We will also email you these documents after you have opened your ',
    reviewImportantInformationTitle: 'Important information',

    termsAndConditionsDocLinkText: 'Terms & Conditions',
    termsAndConditionsDocLinkTitle:
      'Download Terms & Conditions document PDF. This link will open in a new browser window.',
    termsAndConditionsDocLink: 'static/{}/personal-account-terms.pdf',
    termsAndConditionsDocFileName: 'personal-account-terms.pdf',
    termsAndConditionsDocVersion: '0716',
    lendingCodeDocLinkText: 'A guide to the Lending Code',
    lendingCodeDocLinkTitle:
      'Download Lending Code PDF. This link will open in a new browser window.',
    lendingCodeDocLink: 'static/lending-code.pdf',
    lendingCodeDocFileName: 'lending-code.pdf',
    lendingCodeDocVersion: '1.0',
    currentTariffDocLinkText: 'Tariff details',
    currentTariffDocLinkTitle:
      'Download Tariff Details PDF. This link will open in a new browser window.',
    currentTariffDocLink: 'static/{}/current-account-tariff.pdf',
    currentTariffDocFileName: 'current-account-tariff.pdf',
    currentTariffDocVersion: '0816',
    savingsTariffDocLinkText: 'Tariff details',
    savingsTariffDocLinkTitle:
      'Download Tariff Details PDF. This link will open in a new browser window.',
    savingsTariffDocLink: 'static/{}/savings-account-tariff.pdf',
    savingsTariffDocFileName: 'savings-account-tariff.pdf',
    savingsTariffDocVersion: '08a16',
    CA31DocLink: 'static/{}/CA31.pdf',
    CA31DocLinkText: 'Current Account Control Factsheet',
    CA31DocLinkTitle:
      'Download Current Account Control Factsheet PDF. This link will open in a new browser window.',
    CA31DocVersion: '1.0',
    financialServicesCompensationSchemeDocLinkText:
      'Financial Services Compensation Scheme Information Sheet',
    financialServicesCompensationSchemeDocLinkTitle:
      'Download Financial Services Compensation Scheme Information Sheet PDF. This link will open in a new browser window.',
    financialServicesCompensationSchemeDocLink:
      'static/FSCS_Information_Sheet_DU728.pdf',
    financialServicesCompensationSchemeDocName:
      'FSCS_Information_Sheet_DU728.pdf',
    financialServicesCompensationSchemeName: 'FSCS_Information_Sheet_DU728.pdf',
    financialServicesCompensationSchemeDocVersion: '1215',

    reviewKeyFeaturesTitle: 'Key features for the',
    reviewOfferRestrictionsTitle: "This offer doesn't include:",
    reviewAcceptTsAndCs:
      'By ticking this box and clicking "Submit" this represents my signature confirming that:',

    // Review page labels - capital LABEL so last section can match up to name of the form element
    reviewLabelsectionPersonalDetails: 'Personal details',

    reviewLabeltitle: 'Title',
    reviewLabelfirstName: 'First Name',
    reviewLabelmiddleName: 'Middle Name',
    reviewLabellastName: 'Last Name',
    reviewLabeldateOfBirth: 'Date of Birth',
    reviewLabelgender: 'Gender',
    reviewLabelmaritalStatus: 'Marital Status',
    reviewLabeldependants: 'No. of Dependants',
    reviewLabeladdresses: 'Address',
    reviewLabelresidentialStatus: 'Residential Status',
    reviewLabeldateMoved: 'Date Moved',
    reviewLabelPreviousaddresses: 'Previous Address',

    reviewLabelsectionContactDetails: 'Contact details',

    reviewLabelemailAddress: 'Email Address',
    reviewLabelpreferredContactMethod: 'Preferred Contact Method',
    reviewLabelphoneNumber: 'Phone Number',

    reviewLabelsectionNationality: 'Nationality',

    reviewLabelnationality: 'Nationality',
    reviewLabelcountryBorn: 'Country of Birth',
    reviewLabelcityBorn: 'City of Birth',
    reviewLabelukCitizen: 'UK Citizen',
    reviewLabelcitizenshipList: 'Additional Citizenships',
    reviewLabeltaxObligations: 'Additional Tax Obligations',
    reviewLabelallTaxObligationsListed: 'All Tax Obligations Listed',

    reviewLabelsectionEmployment: 'Employment details',

    reviewLabelemploymentStatus: 'Employment Status',
    reviewLabelemploymentOccupation: 'Occupation',
    reviewLabelemployerName: 'Employer Name',
    reviewLabelemploymentStartDate: 'Start Date',

    reviewLabelsectionIncome: 'Income',

    reviewLabelgrossAnnualIncome: 'Gross Annual Income',
    reviewLabelnetMonthlyIncome: 'Net Monthly Income',
    reviewLabelincomeOtherAmount: 'Additional Income',
    reviewLabelincomeOtherFrequencyOptions: 'Frequency',

    reviewLabelsectionCA: 'Current Account',

    reviewLabelincomeOtherAccountPurpose: 'Account Purpose',
    reviewLabelincomeOtherPaymentTypeOptions: 'Account Use For',
    reviewLabelincomeOtherPaymentAmount: 'Monthly Pay In',

    reviewLabelsectionSA: 'Savings Account',

    reviewLabelincomeOtherSavingsAmount: 'Pay In Amount',
    reviewLabelincomeOtherSavingsFrequency: 'Frequency',
    reviewLabelincomeOtherSavingsTypeOptions: 'Account Use For',
    reviewLabelincomeOtherSavingsPurpose: 'Account Purpose',

    reviewLabelsectionOutgoings: 'Outgoings',

    reviewLabelmortgageOrRentExpenditure: 'Mortgage / Rent',
    reviewLabelexpenditureOther: 'Other',

    // DGS Documents
    reviewAcceptSaDgs:
      'Yes, I agree to the Savings Account Deposit Guarantee Scheme',
    reviewAcceptCaDgs:
      'Yes, I agree to the Current Account Deposit Guarantee Scheme',
    DGSDocLink: 'static/CYB00174_FSCS Information Sheet _079601_v10.pdf',
    DGSDocLinkTitle:
      'Download Deposit Guarantee Scheme Information Sheet PDF. This link will open in a new browser window.',
    DGSDocName: 'Deposit Guarantee Scheme Information Sheet',
    DGSDocFileName: 'CYB00174_FSCS Information Sheet _079601_v10.pdf',
    DGSDocVersion: '10.0',

    // Marketing Prefs
    marketingPrefsTitle: 'Marketing preferences',
    marketingPrefsText:
      "When we have a new product or offer that we think you might be interested in, we'd like to let you know. Please tell us the best way to stay in touch.",

    // Offer Page
    offerItemSelfService: 'Easy to use phone and internet banking',
    offerItemWithInterest:
      'Ongoing 2% AER (variable) interest on balances up to £3000',
    offerItemDebitContactless:
      'A Debit MasterCard with Contactless functionality as well as allowing you to withdraw cash at any ' +
      brand.bankName +
      ' ATM or UK ATM, subject to available funds. We will tell you your daily ATM withdrawal limit when we send you your Debit MasterCard.',
    offerItemDebitContactlessLimited:
      'A Debit MasterCard Online Only card with Contactless functionality allowing you to withdraw up to £350 a day at any ' +
      brand.bankName +
      ' ' +
      (brand.appendBank ? '' : 'Bank') +
      ' ATM or UK ATM, subject to available funds',

    offerItemCaControl:
      'A Debit MasterCard Online Only card with Contactless functionality allowing you to withdraw up to £350 a day at any Clydesdale ATM or UK ATM, subject to available funds.',
    // ready cash offers
    offerItemNoFees: 'There are no fees or charges for this account.',
    offerItemNoCreditInterest: "This account doesn't pay credit interest.",
    offerItemNoOverdrafts: 'Overdrafts are not permitted.',
    offerItemNoBorrowing:
      'Borrowing is not available on this account. Requests for unplanned borrowing will usually be declined. {termsAndConditionsDoc}',
    offerItemDebitCard:
      'You will receive a Debit MasterCard Online Only card with non contactless functionality allowing you to withdraw up to £350 a day at any Clydesdale ATM or UK ATM, subject to available funds.',
    offerItemDeposits:
      'Your eligible deposits with Clydesdale Bank PLC are protected up to a total of £75,000 by the Financial Services Compensation Scheme, the UK’s deposit guarantee scheme. This limit is applied to the total of any deposits you have with Clydesdale Bank, Yorkshire Bank and B. Any total deposits you hold above the limit between these brands are unlikely to be covered. Please see <a href="http://www.cbonline.co.uk/resources/b82e172a-b00f-4783-973b-e4399da349e4/fscs_2015_online-leaflet.pdf" target="_blank" title="www.fscs.org.uk. This link will open in a new browser window">FSCS leaflet<span class="screenreader"> This link will open in a new browser window</span></a> for further information or visit <a href="http://www.fscs.org.uk" target="_blank" title="www.fscs.org.uk. This link will open in a new browser window">www.fscs.org.uk<span class="screenreader"> This link will open in a new browser window</span></a>',
    offerItemDeposits2:
      'Your eligible deposits with Clydesdale Bank PLC are protected up to a total of £75,000 by the Financial Services Compensation Sheet, UK’s deposit guarantee scheme. The limit is applied to the total of any deposits you have with Clydesdale and Yorkshire bank. Any deposits you hold above the limit between these brands are unlikely to be covered. B is part of Clydesdale Bank and is not a separate entity for the purposes of this scheme. Please ask for further information, or visit <a href="http://www.fscs.org.uk" target="_blank" title="www.fscs.org.uk. This link will open in a new browser window">www.fscs.org.uk<span class="screenreader"> This link will open in a new browser window</span></a>',
    offerItemCancelation:
      'You can cancel your agreement with us within 14 days of opening the account, or from the day you receive the Terms & Conditions if later, by contacting us in branch, phone or in writing. You will need to repay any debit balance, interest and fees incurred within 30 days from the date you tell us you want to cancel it.',

    offerItemInterestCalculation: 'Interest calculated daily',
    offerItemInterestPaid:
      'Interest paid last business day of each calendar quarter',
    offerItemNoWithdrawnCharge: 'No charge for withdrawals',
    offerItemnonContactlessCard: 'Non-Contactless Debit MasterCard',
    offerItemTieredRates: 'Tiered interest rates',
    offerItemTransactionFees:
      'Transaction fees apply when you use your debit card abroad. Details of the limits and charges which apply are provided in the tariff guide for the account on which your card is issued.',
    offerItemWithdrawalMadeByTransfer:
      'Withdrawal may only be made by transfer to your linked current account either in branch or using internet/telephone banking.',
    offerItemInclusionMortgageOffsetting:
      'This account is eligible for inclusion in mortgage offsetting arrangements. Any credit balance can be used to set against the debit balance on your Offset Mortgage held with us and so reduce the interest payable on your mortgage. Full details can be found in the Offsetting section of your Terms & Conditions.',

    // happy path savings items
    offerItemHappynonContactlessCard:
      'A non-contactless Debit MasterCard as well as allowing you to withdraw cash at any ' +
      brand.bankName +
      ' ATM or UK ATM, subject to available funds. We will tell you your daily ATM withdrawal limit when we send you your Debit MasterCard.',
    offerItemHappyWithdrawalMadeByTransfer:
      'Withdrawal of funds by transfer to your linked current account either in branch or using internet/telephone banking.',

    // KEY FEATURES FOR INSTANT SAVINGS
    interestRatesInfoNoGross:
      'For interest rates, please refer to the savings account tariff for personal customers, our <a href="' +
      brand.bankWebsite +
      '/personal/savings/interest-rates-and-charges/" target="_blank" title="' +
      brand.bankWebsite +
      '/personal/savings/interest-rates-and-charges/ This link will open in a new browser window">website <span class="screenreader">This link will open in a new browser window</span></a> or the notice displayed in branch.',
    interestRatesInfo:
      'For interest rates, please refer to the savings account tariff for personal customers, our <a href="' +
      brand.bankWebsite +
      '/personal/savings/interest-rates-and-charges/" target="_blank" title="' +
      brand.bankWebsite +
      '/personal/savings/interest-rates-and-charges/ This link will open in a new browser window">website <span class="screenreader">This link will open in a new browser window</span></a> or the notice displayed in branch. Interest will be paid gross.',
    interestCalculation:
      'Interest is calculated on a daily basis and paid gross on the last business day of each calendar quarter.',
    nonContactlessCard: 'Debit MasterCard online only non-contactless card.',
    noWithdrawnCharge:
      'No charge for withdrawals - Transaction fees apply when you use your debit card abroad. Details of the limits and charges which apply are provided in the tariff guide for the account on which your card is issued.',
    accountAccess:
      'You can access your account via Internet, telephone banking, ATM or branch',

    // KEY FEATURES FOR SAVINGS PLUS
    offsetAgainstMortgage:
      "Offset your Current account and Savings Account Plus against a Clydesdale Bank Offset Mortgage – you'll earn interest on linked savings accounts when the linked credit balances are greater than the balance owed on the mortgage",
    withdrawalMadeByTransfer:
      'Withdrawals must be made by transfer to your linked current account or via our telephone, internet and mobile banking services.',
    withdrawalFundsLinked:
      'You may only withdraw funds by transfer to your linked current account either in branch or using internet/telephone banking.',

    // KEY FEATURES FOR SIGNATURE SAVINGS
    inclusionMortgageOffsetting:
      "This account is eligible for inclusion in mortgage offsetting arrangements. Offset your Signature Current Account and Signature Savings Accounts against a Clydesdale Bank Offset Mortgage - you'll earn interest on linked savings accounts when the linked credit balances are greater than the balance owed on the mortgage",

    offerPageUnsuccessfulTitle:
      'We are sorry, it appears that you are not eligible for the {productTitle} as you don’t hold the appropriate current account',
    offerPageDowngradeTitle:
      'Unfortunately you have been unsuccessful for the {productTitle}',
    offerPageAlternativeOfferTitle: 'However we can offer you our ',
    offerPageAlternativeOfferTitleMulti: 'We can offer you our ',
    offerPageTitle:
      'We are pleased to offer you {productArticle} {productName}',
    offerPageAltTitle: 'We are please to offer you a ',
    offerPageSubTitle: 'This offer includes:',
    offerPageIntroTitle:
      'This section contains certain key information relating to the Readycash Account. Full details are contained in your Terms & Conditions and Tariff attached below which you should read.',

    offerPageKeyFeaturesTitle: 'Key features for',
    offerPageofferRestrictionsTitle: "This offer doesn't include:",
    offerPageDocumentToReadSectionTitle: 'Documents for you to read and save:',
    offerPageDeclineOffer:
      "If there's something you're undecided about, please call us on " +
      brand.phoneNumber +
      ' or go into a branch.',
    offerConditionsIntro:
      'You will receive these by email after you have opened the account.',
    offerTandCQuestion:
      'By ticking this box and clicking "Accept offer" this represents my signature confirming that:',
    offerPageContinue: 'Do you wish to continue with the offer of a ',
    offerItemReadyCash:
      'A Debit MasterCard Online Only card with Non contactless functionality allowing you to withdraw up to £350 a day at any Clydesdale ATM or UK ATM, subject to available funds.',
    offerItemCaDirectCaPlus:
      'A Debit MasterCard with Contactless functionality as well as allowing you to withdraw cash at any Clydesdale ATM or UK ATM, subject to available funds. We will tell you your daily ATM withdrawal limit when we send you your Debit MasterCard.',

    offerPageHeader: 'Offer',
    openAccountButton: 'Yes, open my account',
    declineAccountButton: 'No, do not proceed',
    downgradedOfferPageEmail:
      'We will also email you these documents after you have opened the account',

    // Offer Page Mandate
    mandateTitle: '',
    mandateParagraph:
      "I confirm that by clicking the 'Yes, open my account' button this represents my signature and that I am opening an account and reconfirm my authority previously provided.",

    // Mutli Offer & Modal
    altOpenAccountButton: 'Accept offer',
    altDeclineAccountButton: 'Decline offer',
    offerCancelApplicationBtn: 'Cancel application',
    offerCancelApplicationModalTitle:
      'Are you sure you want to cancel this application?',
    offerCancelApplicationConfirm: 'Yes',
    offerCancelApplicationDecline: 'No',
    offerCancelIntro:
      'If you do not wish to proceed with your application you can cancel below',

    // Mandate items
    mandateBullet1: 'I wish to apply for the account',
    mandateBullet2:
      'I have read and accept the Terms & Conditions and Tariff. I have also saved or printed a copy of the Terms & Conditions and Tariff',
    mandateBullet3:
      'I acknowledge receipt of the Financial Services Compensation Scheme Information Sheet',
    mandateBullet4:
      'I authorise you to undertake any necessary searches and credit checks required to validate my identity and address, and',
    mandateBullet5:
      'If my application is accepted and I proceed to open the account, I authorise you to debit to the account all cheques, orders, payments and withdrawals signed or otherwise authorised by me. I also authorise you to debit to the account all transactions made by using any debit cards that you may issue to me',
    mandateBullet6:
      'I authorise you to undertake any necessary searches required to validate my identity and address, and',
    mandateBullet7:
      'If my application is accepted and I proceed to open the account, I authorise you to debit to the account all withdrawals signed or otherwise authorised by me.',
    mandateBullet8:
      'If my application is accepted and I proceed to open the account, I authorise you to debit to the account all withdrawals signed or otherwise authorised by me. I also authorise you to debit to the account all transactions made by using any debit cards that you may issue to me',
    mandateBullet9: 'I wish to apply for this account',
    mandateBullet10:
      'I have read and accept the Terms & Conditions and Tariff. I have also saved or printed a copy of the Terms & Conditions and Tariff',
    mandateBullet11:
      'I acknowledge receipt of the Financial Services Compensation Scheme Information Sheet',
    mandateBullet12:
      'I authorise you to undertake any necessary searches and credit checks required to validate my identity and address, and',
    mandateBullet13:
      'If my application is accepted and I proceed to open the account, I authorise you to debit to the account all cheques, orders, payments and withdrawals signed or otherwise authorised by me. I also authorise you to debit to the account all transactions made by using any debit cards that you may issue to me',

    // Deferred Page
    deferredPageHeader: 'Deferred',
    deferredPageTitle: 'We need more time to look at your application',
    deferredPageExplanation:
      'A team member needs to go over your application in more detail. We will do this within two working days and you will be notified by email or SMS with a link to log in and see the decision.',

    // ID Deferred Page
    idDeferredPageHeader: 'Verify your identity',
    idDeferredPageTitle: 'We need to see your ID in person',
    idDeferredPageExplanation:
      "We have been unable to verify your identity. In order to complete your application, please visit your <a target='_blank' href='" +
      brand.bankWebsite +
      '/personal/online-locator/' +
      "'>local branch</a> with an official form of ID.",
    idDeferredPageNextStepsItems: ['Passport', 'Driving license'],
    idDeferredLinkTitle:
      'Download ID Requirements PDF. This link will open in a new browser window',
    idDeferredLinkText: 'What ID can I bring?',
    idDeferredLinkUrl:
      'http://www.cbonline.co.uk/wcm-media/CYB-Identificatio-Requirements.pdf',

    // Contact Bank Page
    contactBankPageHeader: 'We need your number',
    contactBankPageTitle: 'We need your number',
    contactBankPageExplanation:
      'To continue your application we need you to update your mobile details. Please visit your nearest branch or call us on ' +
      brand.phoneNumber +
      '.',

    // Account Locked Page
    accountLockedPageHeader: 'Account Locked',
    accountLockedPageExplanation1:
      "Sorry. We've had to lock your account to ensure it's kept secure.",
    accountLockedPageExplanation2:
      'You can unlock your account by resetting your password.',
    accountLockedPageExplanation3:
      'Alternatively, you can contact support on <strong>' +
      brand.phoneNumber +
      '</strong>.',
    accountLockedPageExplanation4:
      'Please quote your ID: <strong>{quote_id}</strong>',
    accountLockedPageResetPasswordButtonLabel: 'Reset your password',

    // Session Timeout Text
    sessionTimeout: 'Your session has timed out.',

    // Sorry Page
    sorryPageHeader: 'Sorry',
    sorryPageTitle:
      'We are sorry but after careful consideration we have declined your application',
    sorryPageExplanation1:
      'We use a Credit Scoring System and information from credit reference agencies, Experian and Callcredit, to ensure we assess all credit applications fairly and consistently. You can request a copy of your report from the credit reference agencies by clicking on the link below.',
    'sorryPageExplanation1-savings':
      'We use an identity verification system and information from credit reference agencies, Experian and Call credit, to ensure we assess all applications fairly and consistently.',
    sorryPageExplanation2:
      'If you think there are special circumstances related to your application, you can call us to discuss it on ' +
      brand.phoneNumber +
      '. Lines are open Monday to Friday 08:00 to 20:00, Saturday 09:00 to 17:00 and closed Sunday.{findOutMore}  We will send you a letter in the post to confirm this decision.',
    'sorryPageExplanation2-savings':
      'The details of our identity verification system are confidential and we’re unable to give you any more specific reasons for declining your application. You can request a copy of your report from the credit reference agencies by clicking on the link below.',
    sorryFindOutMore:
      'We may be able to offer you an alternative current account to the one you applied for. Please call us to find out more.',
    sorryPageFormLink:
      'http://www.experian.co.uk/consumer/statutory-report.html',
    sorryPageFormLink2: 'http://www.callcredit.co.uk',
    sorryPageFormLinkText: 'Click here to visit Experian website',
    sorryPageFormLinkText2: 'Click here to visit Callcredit website',
    sorryPageFormLinkTitle: 'This link will open in a new window',
    sorryPageFormLinkTitle2: 'This link will open in a new window',

    // Decline Page
    declinePageTitle:
      'We are sorry, it appears that you are not eligible for the {productName} as you don’t hold the appropriate current account. We note that you did not proceed with our offer of an alternative product.',
    declinePageParagraph1: undefined,
    declinePageParagraph2: undefined,
    declinePageLink1: undefined,
    declinePageLink2: undefined,

    // Registration Page
    registrationPageHeader: 'Registration',
    registrationPageTitle: 'Congratulations, your account has been opened',
    registrationPageSubTitle:
      "Your account details and information you'll need to make a note of",
    registrationPageParagraph1:
      'If you haven’t already registered for internet and telephone banking, you can do so below',
    registrationPageParagraph2:
      "For Telephone Banking you'll need your customer number – again it's above, and your telephone PIN – which you can set up below.",
    registrationPageBulletParagraph:
      "For Internet Banking you'll need the following details to log in:",
    registrationPageBullet1: 'your customer number - which is above',
    registrationPageBullet2:
      'your password - which you created at the start of this application',
    registrationPageBullet3:
      'your security questions for Internet Banking - which you can set up below',
    registrationPageErrorMessage:
      'There has been a problem registering your {0} credentials. The reason is {1}.',

    alreadyRibRegistered:
      "It looks like you're already signed up for internet banking, you don't need to do anything more here.",
    alreadyTBRegistered:
      "It looks like you're already signed up for telephone banking, you don't need to do anything more here.",

    securityQuestionsTitle: 'Security questions for Internet Banking',
    securityQuestionsSubTitle:
      'Please choose some security questions and answers. These will be used when you log in to internet banking.',

    securityPageLoadingMessage: 'Loading...',
    securityPageSubmissionMessage: 'Submitting answers...',

    securityQuestionDropdownValidationMessage:
      "Sorry, you can't select the same question twice.",
    securityQuestionInputValidationMessage:
      'Your answer must be 6-20 characters long, and only contain letters and numbers.',
    securityQuestionDropdownHelpText:
      'These questions are a safeguard against the risk of fraud and make your log in to internet banking more secure.',
    securityQuestionInputHelpText:
      'Type in a simple answer that you can easily remember for each question. Your answer must be 6-20 characters long, and only contain letters and numbers.',
    telephonePinTitle: 'Telephone Banking',
    telephonePinHelpMessage:
      "Your telephone PIN is a special code you'll use to identify yourself when you phone up to use telephone banking. It's an important security measure. It needs to be a 4 digit number which you can easily remember. Don't use the same number more than three times, or have any sequential numbers in there like 1234.",
    telephonePinValidationMessage:
      'Pick a 4 digit number, with no consecutive numbers, and without using the same number four times.',
    telephonePin2HelpMessage:
      'This needs to be exactly the same as the PIN entered in the box above.',
    telephonePin2ValidationMessage: "Try again? The PIN numbers didn't match.",
    registrationTCsTitle:
      'Download and save the Terms & Conditions for Telephone and Internet Banking for your records. These will also be emailed to you.',
    registrationTsAndCsDocLink: 'static/rib-tb-terms.pdf',
    registrationTsAndCsDocVersion: '0815',
    registrationTsAndCsText:
      'Terms & Conditions for Telephone and Internet Banking',
    registrationTsAndCsDocLinkTitle:
      'Download Terms & Conditions for telephone and internet banking PDF. This link will open in a new browser window.',
    registrationAcceptTCs:
      'I confirm by ticking this box that I agree to the Terms & Conditions above.',
    registrationAcceptTCsValidationMessage:
      'You need to agree in order to carry on.',

    // Submission Page
    submissionPageHeader: 'Submission',
    submissionPageTitle: 'Thank you for sending us your application',
    submissionPageText: 'We are working on it right now for you.',

    // Security Page
    securityPageTitle:
      'We need to ask you a few questions to check your identity',
    timerSectionTitle:
      "As a security measure, there's a time limit on this section. Please answer the questions within 5 minutes.",
    timerSectionTimeUnitDescription: 'mins',
    timerSectionTimeUnitExpiredDescription:
      "Sorry, but you've run out of time.",

    // Account Opened Page
    accountOpenedPageHeader: 'Account Opened',
    accountOpenedPageTitle: "Good news, you're all done",

    accountOpenedSection1Title: 'Check your email',
    accountOpenedSection1Bullet1:
      "Shortly we will send you an email with important information for you to read and save. Check your email filters in case it's gone straight to your junk/ spam folder and you can't see it in your inbox.",
    accountOpenedSection1Bullet2:
      'You’re all registered for internet banking too. You can use this straight away by going to the login button at the top right of any page on <a href="' +
      brands.CB.bankWebsite +
      '" target="_blank" title="www.cbonline.co.uk This link will open in a new browser window">www.cbonline.co.uk <span class="screenreader">This link will open in a new browser window</span></a> or <a href="' +
      brands.YB.bankWebsite +
      '" target="_blank" title="www.ybonline.co.uk This link will open in a new browser window">www.ybonline.co.uk <span class="screenreader">This link will open in a new browser window</span></a>. You\'ll need your customer number, password and security details.',
    accountOpenedSection2Title: 'Look out for your post',
    accountOpenedSection2Bullet1:
      'You will receive a welcome letter which will confirm the details of your new account, please read through and send us back your specimen signature, as we’ll need this so you can make certain transactions on your account.',
    accountOpenedSection2Bullet2:
      'Your Debit MasterCard and PIN are on their way. These will come separately and will be with you within 3-5 working days.',
    accountOpenedSection3Title: 'Useful links',
    accountOpenedSection3Bullet1:
      'Download our mobile banking app <a href="' +
      brand.monetiseLink +
      '" target="_blank" title="Click here to download our mobile banking app. This link will open in a new browser window">here <span class="screenreader">Click here to download our mobile banking app. This link will open in a new browser window</span></a>',
    accountOpenedSection3Bullet2:
      '<a href="' +
      brand.faqsLink +
      '" target="_blank" title="FAQs. This link will open in a new browser window">FAQ\'s <span class="screenreader">This link will open in a new browser window</span></a> to help answer any queries you may have',
    accountOpenedSection3Bullet3: '',
    accountOpenedSection3Bullet4:
      '<a href="' +
      brand.faqsSavingsLink +
      '" target="_blank" title="FAQs. This link will open in a new browser window">FAQ\'s <span class="screenreader">This link will open in a new browser window</span></a> to help answer any queries you may have',
    accountOpenedSection4Title: 'Contact us',
    accountOpenedSection4Bullet1:
      'If you want to include your new account in mortgage offsetting arrangements as this will not be done automatically.',
    accountOpenedSection4Bullet2: '',
    accountOpenedSection4Bullet3:
      'If you would like to arrange planned borrowing, subject to eligibility.',
    accountOpenedSection5Title: 'Ways to contact us',
    accountOpenedSection5Bullet1:
      'Call us on ' + brand.phoneNumber + ' or pop in to your local branch.',

    // Portal Page
    portalPageHeader: 'Portal',
    portalPageTitle: 'Your saved applications',
    portalPageSubTitle: 'Pick an application to carry on with',

    // Login Page
    loginPageHeader: 'Login',
    loginPageTitle: 'Your saved application',
    loginPageNextButtonLabel: 'Please log in to carry on',
    usernameLabel: 'Please enter your Customer Number or Username',
    usernameValidationMessage:
      'Your Customer Number should be a 10 digit number starting with "10". Your Username should be between 6 and 16 characters. It can be made up of letters and numbers and is case sensitive. If you are having difficulty finding these, please call us on ' +
      brand.phoneNumber +
      '.',
    usernameHelpMessage: undefined,
    passwordValidationMessage:
      'If you are having difficulty remembering this, please call us on 0800 028 3632.',
    passwordHelpMessage:
      'Your Internet Banking Password was set up during the registration process.',
    passwordLabel:
      'Please enter the following characters from your Internet Banking login password. Characters are case sensitive.',
    passwordCharacterPrefix: 'Character ',
    goneWrongMessage:
      'Can you check the details and try again please? Something went wrong but it might work if you try again.',
    tooManyRetries:
      'You have exceeded the maximum number of login attempts. Please try again later.',
    cannotBeLoggedIn:
      'Sorry we cannot log you in at this time. Please contact us for support.',

    // OTP Authentication Overlay
    OTPTitle: "We've sent a passcode to your mobile",
    OTPAuthenticationTitle:
      "We've sent a passcode to your mobile ending {partial-phone-number}",
    OTPAuthenticationAltTitle: "We've sent a passcode to your mobile",
    OTPAuthenticationSubTitle:
      "You should have received a text on your mobile ending {partial-phone-number} You can't proceed past this point unless we have a mobile number saved for you. If you need help call us on " +
      brand.phoneNumber +
      '.',
    OTPAuthenticationAltSubTitle:
      "You should have received a text on your mobile. You can't proceed past this point unless we have a mobile number saved for you. If you need help call us on " +
      brand.phoneNumber +
      '.',

    OTPAuthenticationTitleResent: "We've sent you another passcode.",
    OTPAuthenticationSubTitleResent:
      'Check your mobile ending {partial-phone-number}',
    passcodeValidationMessage:
      'This passcode is required and should be a number of exactly 10 characters.',
    OTPAuthenticationTitleNoOTP: 'Something went wrong',
    OTPAuthenticationSubTitleNoOTP: 'Please try that again.',
    OTPAuthenticationTitleInvalidOTP: "That's not the right passcode.",
    OTPAuthenticationSubTitleInvalidOTP:
      "Try again please. The passcode you entered isn't the same as the one we texted you.",

    // Switch Page
    switchPageHeader: 'Switch',
    switchPageTitle: 'Switch to us with the Current Account Switch Service',
    switchPageText1:
      'If you have an agreed overdraft facility on your old account you will need to arrange a planned borrowing limit with us prior to switching your account to ensure that you can fully transfer any debit balance as part of your switch. You can arrange planned borrowing, subject to eligibility, just pop into your nearest branch or call us on 0800 678 3350.',
    switchPageText2:
      "Switching your current account to us from another bank is straightforward with the Current Account Switch Service, we'll do everything for you. We'll contact your old bank so you don't have to worry about letting them know. The Current Account Switch Service is free to use and once you have chosen and agreed your switch date with us, we guarantee it will only take 7 working days, backed by the Current Account Switch Guarantee. On your switch date, your old account will be closed and all your payments and credit balance will be transferred to your new " +
      brand.bankName +
      ' account.',
    switchPageText3:
      '<strong>Once your switch has started it cannot be stopped</strong>, but the guarantee means that if anything goes wrong we’ll refund any interest or charges made on either your old account or the new one as a result.',
    switchPageText4:
      "If you're not eligible for the Current Account Switch Service, or you don't want to use it, the Payment Transfer Service lets you transfer your Direct Debits and standing orders from your old account to your new account over a 3 month period.",

    wantsToSwitch:
      "If you want to use either of these switching services, please click on the 'Yes' button.",
    wantsToSwitchValidationMessage: 'This is required.',
    switchDetailsTitle:
      'Please fill in the following details. Use the details from the old account you’re switching from, and not the new one you’ve just opened.',
    switchAccountNameValidationMessage:
      'Your account name must be no more than 18 characters long.',
    switchAccountNameHelpMessage:
      'This is the name shown on your account statement.',
    switchAccountNumberValidationMessage: 'This must be 8 numbers long.',
    switchAccountNumberHelpMessage:
      'The account number will appear on your account statements.',
    switchSortCodeValidationMessage: 'This is 6 numbers long.',
    switchSortCodeHelpMessage:
      'You will see your sort code on your account statements, usually next to the account number.',
    switchDebitCardPanLabel: 'Your 16-digit Card Number',
    switchHasDebitCardValidationMessage: 'This is required.',
    switchDebitCardPanValidationMessage:
      'This is the long number on the front of the card.',
    switchDebitCardPanHelpMessage:
      'This is the main number across the front of the card, typically printed in bigger characters and usually 16-19 numbers long.',
    switchDebitCardExpirationValidationMessage:
      'Please use numbers without any extra characters, so for example January 2017 should be written like this: 0117. The card must not have expired.',
    switchDebitCardExpirationHelpMessage:
      "This will be shown on the card as a month and year, typically next to a statement such as 'Expires end'.",
    switchTypeValidationMessage: 'This is required.',
    switchTypeTitle: 'Please choose a switch option.',
    switchTypeFullSwitch:
      'A full switch using the Current Account Switch Service will guarantee that once you have chosen and agreed the switch date with us that the full balance and regular payments associated with your old account will be switched to your new account and your old account will be closed. You will be advised of regular payments that cannot be automatically transferred and any payments made to your old account will be redirected to your new account.',
    switchTypePaymentSwitch:
      'The Payment Transfer Service allows you to choose which payments you would like to transfer across to your new account, your old account will not be closed.',
    switchDateValidationMessage:
      'The date cannot be in the past. Please remeber to select a date at least 7 working days from now, which is not a weekend or Bank Holiday.',
    switchDateHelpMessage:
      'This is the date you would like the switch to take place.',
    switchDateGuidance:
      'Please select a date at least 7 working days from now, which is not a weekend or Bank Holiday.',
    switchCloseOldAccount:
      'Yes, I agree to you closing my old current account when the switch to my new one is complete.',
    switchCloseOldAccountValidationMessage:
      'Please confirm your consent to continue.',
    switchCloseOldAccountHelpMessage:
      "This means that we'll transfer your balance, direct debits and standing orders before closing the account.",
    switchFullTsAndCsDocLink: 'static/switch-terms-' + brand.bankCode + '.pdf',
    switchFullTsAndCsDocLinkTitle:
      'Download Current Account Switch Services Terms & Conditions PDF. This link will open in a new browser window.',
    switchFullTsAndCsDocVersion: '1.0',
    switchFullTsAndCsText: 'Current Account Switch Service Terms & Conditions',
    switchAcceptFullTCs: 'Yes, I agree to the Terms & Conditions above',
    switchAcceptFullTCsValidationMessage: 'Please agree in order to continue.',
    switchPaymentsTsAndCsDocLink:
      'static/payment-transfer-' + brand.bankCode + '.pdf',
    switchPaymentsTsAndCsDocLinkTitle:
      'Download Payment Transfer Service Terms & Conditions PDF. This link will open in a new browser window.',
    switchPaymentsTsAndCsDocVersion: '1.0',
    switchPaymentsTsAndCsText: 'Payment Transfer Service Terms & Conditions',
    switchAcceptPaymentsTCs: 'Yes, I agree to the Terms & Conditions above',
    switchAcceptPaymentsTCsValidationMessage:
      'Please agree in order to continue.',

    // Map Switch Response Codes to Messages
    switchCode000: 'Your switch has been successful',
    switchCode340:
      'Sorry, this product is not eligible for switching. However you can do a Payment Transfer. Please call ' +
      brand.phoneNumber +
      ' if you require further assistance',
    switchCode365:
      'Sorry, this product is not eligible for switching. Please call ' +
      brand.phoneNumber +
      ' if you require further assistance',
    switchCode366:
      'Sorry, you have inserted the wrong sort code, account number or 16 digit card number. Please re-enter to proceed.',
    switchCode364:
      'Sorry, we cannot switch your account at this stage as we have encountered a difficulty. Please call us on ' +
      brand.phoneNumber +
      ' ',
    switchCode367:
      "We're sorry but the provider of the account you wish to switch does not support the Current Account Switch Service. Please select an account which is supported by the Current Account Switch Guarantee Service or call us on " +
      brand.phoneNumber +
      '.',
    switchCode345:
      'Sorry, the switch date cannot be a weekend or a bank holiday. Please choose another date which is neither.',
    switchCode346:
      'Sorry, the switch date must be 7 or more working days from now.',
    switchCode347:
      'Sorry. Your switch date is too far in advance. Please pick a date that is more than 7, and less than 90 days from today.',
    switchCode393:
      "Sorry. We've encountered a technical problem. Please try again later or call us on " +
      brand.phoneNumber +
      '.',
    switchCode394:
      'Sorry, there is a difficulty with your new account. Please call us on ' +
      brand.phoneNumber +
      ' ',
    switchCode395:
      "Sorry. We've encountered a technical problem. Please try again later or call us on " +
      brand.phoneNumber +
      '.',
    switchCode349:
      "Sorry. We've encountered a technical problem. Please try again later or call us on " +
      brand.phoneNumber +
      '.',
    switchCode350:
      'Sorry, we have encountered a difficulty with the data input. Please contact us on ' +
      brand.phoneNumber +
      '.',
    switchCode353:
      'The switch date chosen is in the past. Please reselect a date 7 or more working days from now',
    switchCode380:
      'Sorry, this product is not eligible for The Product Transfer Service. Please call ' +
      brand.phoneNumber +
      ' if you require further assistance',
    switchCode402:
      'Sorry, the bank you are switching from only supports The Payment Transfer Service. If you require further information contact us on ' +
      brand.phoneNumber +
      '.',
    switchCode403:
      "We're sorry but the provider of the account you wish to switch does not support the Current Account Switch Service. Please select an account which is supported by the Current Account Switch Guarantee Service or call us on " +
      brand.phoneNumber +
      '.',
    switchCode398:
      "Sorry. We've encountered a technical problem. Please try again later or call us on " +
      brand.phoneNumber +
      '.',
    switchCode801:
      "Sorry. We've encountered a technical problem. Please try again later or call us on " +
      brand.phoneNumber +
      '.',
    switchCode355:
      "Sorry. We've encountered a technical problem. Please try again later or call us on " +
      brand.phoneNumber +
      '.',
    switchCode358:
      "Sorry. We've encountered a technical problem. Please try again later or call us on " +
      brand.phoneNumber +
      '.',
    switchCode359:
      "Sorry. We've encountered a technical problem. Please try again later or call us on " +
      brand.phoneNumber +
      '.',
    switchCode348:
      'Sorry. You seem to have already applied to switch this account. If you require more information call us on ' +
      brand.phoneNumber +
      '.',
    switchCode361:
      "Sorry. We've encountered a technical problem. Please try again later or call us on " +
      brand.phoneNumber +
      '.',
    switchCode362:
      "Sorry. We've encountered a technical problem. Please try again later or call us on " +
      brand.phoneNumber +
      '.',
    switchCode363:
      "Sorry. We've encountered a technical problem. Please try again later or call us on " +
      brand.phoneNumber +
      '.',
    switchCode389:
      "We're sorry but we do not have a current mailing address for you. Please contact us on " +
      brand.phoneNumber +
      ' so that we can update your details and allow you to proceed.',
    switchCodeDefault:
      'Sorry, something has gone wrong creating your switch application',

    // Authentication Page
    authPageHeader: 'Application',
    authPageSubtitle: 'Please login to continue',
    authPageTitle: 'Authentication',
    authFormTitle: 'Existing customer authentication',
    authFormSubTitle:
      'To help us find your customer details, please complete the following authentication questions',
    hasCustomerName: 'Do you have a customer number/username?',
    hasCustomerNameHelpMessage:
      'Your Customer Number can be found on your internet banking welcome letter. You can also use the Username you created when you started your application.',
    authChallengeSecurityQuestionValidationMessage:
      'This is the answer to the internet banking security question you selected at the time of registration. Please call us if you need help.',
    authPageContact:
      'If you need help with your application, or need to update your personal information, please call us on ' +
      brand.phoneNumber,

    authBankQuestion: 'Please let us know where you have an account',
    authBankIdHelpMessage:
      'Please indicate the bank with which you hold an account',
    authFirstNameQuestion: 'First Name',
    authFirstNameHelpMessage:
      'Your first name, as shown on your passport or identification.',
    authLastNameQuestion: 'Last Name',
    authLastNameHelpMessage:
      "Your last name, as shown on your passport or identification. If your name has changed, for example because of marriage, make sure you use the name that you're officially registered with. This must also match our records.",
    authGenderQuestion: 'Gender',
    authGenderHelpMessage: 'This is just to help identify you.',
    authDateOfBirthQuestion: 'Date Of Birth',
    authDateOfBirthHelpMessage:
      'You must be at least 18 years old to open an account online.',
    authHouseNumberQuestion: 'House Number',
    authHouseNumberHelpMessage:
      'This should be your current address. If you have recently moved, please make sure you have updated your details with us.',
    authStreetQuestion: 'Street',
    authStreetHelpMessage:
      'This should be your current address. If you have recently moved, please make sure you have updated your details with us.',
    authPostcodeQuestion: 'Postcode',
    authContactBankError: 'Please contact us for more help.',
    authPostcodeHelpMessage:
      'This should be your current postcode. If you have recently moved, please make sure you have updated your details with us.',
    authCheckDetailsError:
      'Can you check your details and try again please? Something went wrong but it might work if you try again.',
    authNextButtonText: 'Proceed',
    authFirstNameValidationMessage: 'Please use letters and spaces only.',
    authLastNameValidationMessage: 'Please use letters and spaces only.',
    authDateOfBirthValidationMessage:
      'Please enter a valid date in the following format DD-MM-YYYY.',
    authHouseNumberValidationMessage:
      'Sorry, your house number must be written using numbers and letters only and no longer than 40 characters.',
    authStreetValidationMessage:
      'Your street should be written using numbers and letters only and be no longer than 40 characters.',
    authPostcodeValidationMessage:
      'You have not entered a valid postcode, this should be in the format AB1 2AB.',
    authGenderValidationMessage: 'Please select a gender.',
    authPageLoadingMessage: 'Please wait while we load your details...',

    // Authentication Component
    authChallengeTitle: 'Stepup challenge',
    authChallengeSubtitle: '',
    'security-question-0HelpMessage':
      'This should be the answer you provided during the registration process.',
    telephoneAuthAccessCode: 'Telephone Access Code',
    telephoneAuthAccessCodeValidationMessage:
      'Your Telephone Access code should be a 4 digit number. If you are having difficulty remembering this, please call us on ' +
      brand.phoneNumber +
      '.',
    telephoneAuthAccessCodeHelpMessage:
      'Your Telephone Access Code is a 4 digit code that was set up during the registration process.',
    telephoneAuthSortCode: 'Sort code',
    telephoneAuthAccountNumber: 'Account number',
    debitCardAuthPan: 'Your 16-digit Card Number',
    debitCardAuthSortCode: 'Sort code',
    debitCardAuthAccountNumber: 'Account number',
    panHelpMessage:
      'Your Card Number is a 16 digit number that appears across the front of your debit card.',
    accessCodeHelpMessage:
      'Your Telephone Access Code is a 4 digit code that was set up during the registration process.',
    sortCodeHelpMessage:
      'Your Sort Code is a 6 digit number starting with "82". It will appear on the front of your debit card.',
    accountNumberHelpMessage:
      'Your Account Number is an 8 digit number. It will appear on the front of your debit card and bank statements.',
    panValidationMessage:
      'Your Card Number should be a 16 digit number. If you are having difficulty finding this, please call us on 0800 028 3632.',
    accessCodeValidationMessage:
      'Your Telephone Access code should be a 4 digit number. If you are having difficulty remembering this, please call us on ' +
      brand.phoneNumber +
      '.',
    sortCodeValidationMessage:
      'Your Sort Code should be a 6 digit number without any spaces. If you are having difficulty finding this, please call us on ' +
      brand.phoneNumber +
      '.',
    accountNumberValidationMessage:
      'Your Account Number should be an 8 digit number. If you are having difficulty finding this, please call us on ' +
      brand.phoneNumber +
      '.',

    // Error Page
    upgradeBrowserMessage:
      '<p class="browsehappy">Sorry, our online application does not support your browser. please <a href="http://browsehappy.com/" target="_blank" title="www.browsehappy.com This link will open in a new browser window.">update your browser <span class="screenreader">www.browsehappy.com This link will open in a new browser window.</span></a> to a newer version or try again with a different browser</p><p>You can close this window to return to the site to see other ways to apply.</p>',
    errorPageHeader: 'Error',
    errorPageTitle: 'Sorry there has been a technical problem',
    errorPageText1: 'Something has gone wrong in the background.',
    errorPageText2:
      "While we're sorting it out, can you please call us instead on " +
      brand.phoneNumber +
      '. Lines are open Monday to Friday, 8am-6pm and Saturday 9am-5pm.',

    transactionsErrorBody:
      "Sorry, it looks like there's been a technical problem while loading your transactions. Please try again.",
    transactionsErrorButtonTitle: 'Retry',
    // Setup in Progress Page
    setupInProgressHeader: 'Setup',
    setupInProgressTitle: "Sorry, there's been a slight technical hitch",
    setupInProgressText1:
      'Your account will be open and ready the next working day.',
    setupInProgressText2:
      "We'll let you know as soon as it's available so you can register for online banking, telephone banking and account switching.",
    setupInProgressText3: 'We look forward to being in touch very soon.',

    // Any page
    missingRequiredFields:
      'Call us on ' +
      brand.phoneNumber +
      ' to add the information below and continue with your application:',
    datePickerHelpMessageSuffix:
      'Click on the month/year to start entering your dates. There’s no need to scroll. The date entered should be formatted DD-MM-YYYY.',
    newBrowserWindowTitle: 'This link will open in a new browser window',

    // Projection
    projectionLine2: 'when my projected balance is <strong>below</strong>',
    projectionLine3: '<strong>send</strong> me an alert via',
    projectionLine4: '<strong>SMS</strong>',
    projectionUpdationPopup: 'Your alert has been updated',

    // Timeline Page
    timelineText: 'Your Timeline',
    accountsText: 'Your Accounts',
    mobileAccountText: 'Account List',
    mobileTimelineText: 'Timeline',
    accountBalanceUnavailable: 'Balance unavailable',
    accountTapToReload: 'Click to reload',
    accountBalanceCurrent: 'current',
    accountBalanceAvailable: 'available',
    NoSearchResult: 'These are all your account transactions at present',
    // Digital Statements
    digitalStatementTileContent:
      'View and download your statements whenever you need them.',
    gotoStatements: 'Go to your Statements',
    statementPreferences: 'Statement preferences',
    statementPreferencesModalHeader: 'Statement preferences',
    updateStatementPreferencesModalHeader: 'Update statement preferences',
    digitalModalButton: 'OK',
    digitalModalHeader: 'Statements',
    digitalModalHeader1: 'View your statements whenever you need them',
    digitalModalHeader2: 'Download and print your statements',
    digitalModalHeader3: 'Turn off paper statements',
    digitalModalHeaderContent1:
      'You can view online statements for your accounts right here. They’ve been stripped back to only contain essential information so you may notice they look different from your paper statements.',
    digitalModalHeaderContent2:
      'At the moment, online statements are only available for certain accounts. If you can’t see them, your account doesn’t currently support online statements. ',
    digitalModalHeaderContent3:
      'You can download and print your statements straight from your mobile, tablet or computer.',
    digitalModalHeaderContent4:
      'If your account is set up to display online statements, you also have the option of turning off paper statements and going paperless.',
    digitalErrorMessage1:
      'There’s been a problem loading your statement, please try again later.',
    digitalErrorMessage2: 'When contacting support,',
    digitalErrorMessage3: 'please quote ID: ',
    digitalQuoteID: 'b21ddf',
    // Statement Preferences

    IEPrintIssueModalHeading: 'Your browser isn’t supported', // only for IE case
    IEPrintIssueModalBody1:
      'Sorry, due to some technical issues, you’re not able to download or print online statements using Internet Explorer. Please use another browser to download or print your statement.',
    IEPrintIssueModalBody2:
      'If you do not have access to another browser we do not recommend that you turn off paper statements. For more information, ',
    IEPrintIssueModalBody3:
      'Sorry, due to some technical issues, you’re not able to download or print online statements using Internet Explorer. Please use another browser to download or print your statement. For more information, ',
    checkoutFAQ: 'check out the FAQs.',
    statementPreferenceHeading: 'Manage your statement preferences',
    goPaperfreeLine1: 'Go paperless to only receive statements',
    goPaperfreeLine2: 'online* or keep paper statements turned',
    goPaperfreeLine3: 'on to receive them in the post too.',
    statementPreferenceGotAccountHeader: 'Got an account that isn’t shown?',
    statementPreferenceGotAccountBody1:
      "Some types of accounts aren't currently able to",
    statementPreferenceGotAccountBody2: 'receive paperless statements.',
    statementPreferenceGotAccountInfo1:
      '*Device and browser restrictions may apply.',
    statementPreferenceGotAccountInfoLink1: ' Find out more in our FAQs.',
    statementPreferenceGotAccountInfo2:
      'There may be some problems downloading or printing online statements on certain combinations of devices and browsers. You can',
    statementPreferenceGotAccountInfoLink2: ' find out more in our FAQs.',
    paperfree: 'Paperless',
    paper: 'Paper',
    statementSuccess: 'Your statement preferences have been updated',
    statementPrefernceModalHeader1: 'Going paperless',
    statementPrefernceModalHeader2: 'Keeping paper statements',
    statementPreferenceModalContent1:
      "You can access online versions of your statements whenever you need them. Just log in to internet banking or your mobile app and go to your account. They'll be updated every month and they'll be in the same format as you’re used to.",
    statementPreferenceModalContent2:
      'You can download and print your statements straight from your mobile, tablet or computer.',
    statementPreferenceModalContent3:
      'You’ll still get some documents, such as annual summaries, in the post. And if there are any fees or charges you need to know about, you’ll still get a paper statement for the time being.',
    statementPreferenceModalContent4:
      'If you currently get your statements in Braille, large print or audio or have other special arrangements for your paper statements, you’ll no longer get them.',
    statementPreferenceModalContent5:
      'If you’ve got a joint account, both account holders will stop receiving paper statements, so please make sure the other account holder is also happy not to receive them.',
    statementPreferenceModalContent6:
      'If we’ve already started printing this month’s statement, you’ll still get it in the post.',
    statementPreferenceModalContent7:
      'You can go back to paper statements at any time by changing your statement preferences.',
    statementPreferenceModalContent8:
      'If you ever need a paper statement in the future, just get in touch.',
    statementPreferenceModalContent9:
      "You'll get all your statements in the post, just like you used to.",
    statementPreferenceModalContent10:
      'If you’re changing from paperless to paper statements, your preferences will be updated soon (if this month’s statements have already been processed, you’ll get paper statements in the post from next month).',
    statementPreferenceModalContent11:
      "By clicking 'Continue', you confirm that you understand and agree to the above, and your preferences will be updated.",
    statementPreferenceModalContent12:
      'There may be some problems downloading or printing online statements on certain combinations of devices and browsers. You can',
    statementContinue: 'Update statement preferences',
    backToAccounts: 'Back to accounts',

    statementPreferenceHelpHeader1: 'Choose how you receive your statements',
    statementPreferenceHelpContent1:
      'When you have an account that’s set up to display online statements, you can turn off paper statements and go paperless. To keep receiving statements in the post, simply keep paper statements turned on.',
    statementPreferenceHelpContent2:
      'You can change your preferences at any time, and if you decide to go paperless but need a paper statement in the future, just get in touch.',
    statementPreferenceHelpHeader2: 'View your statements',
    statementPreferenceHelpContent3:
      "Whether you choose to turn paper statements off or not, you can view your statements online whenever you need them. Simply log in to internet banking or your mobile app and go to your account. They'll be updated every month and they'll be in the same format as you’re used to.",
    statementPreferenceHelpHeader3: 'Download and print your statements',
    statementPreferenceHelpContent4:
      'You can download and print your statements straight from your mobile, tablet or computer.',
    statementPreferenceHelpHeader4: 'Before you change your preferences',
    statementPreferenceHelpContent5:
      'If you currently receive your statements in Braille, large print or audio or have other special arrangements for your paper statements, you’ll no longer get them if you go paperless.',
    statementPreferenceHelpContent6:
      'And if you’ve got a joint account, both account holders will stop receiving paper statements, so please make sure the other account holder is also happy not to receive paper statements.',
    statementPreferenceHelpHeader5: 'When your preferences will be updated',
    statementPreferenceHelpContent7:
      'When you change your statement preferences, they’ll be updated as soon as possible. If you make changes after your statement has already been processed, your changes will take effect from the following month.',
    statementPreferenceHelpHeader6: 'What you’ll still get in the post',
    statementPreferenceHelpContent8:
      'Even if you turn paper statements off, you’ll continue to get certain documents, such as annual summaries, in the post. And if there are any fees or charges you need to know about, you’ll still get a paper statement for the time being.',

    // Rename accounts
    renameAccountsLandingPageHeader: 'Rename accounts',
    renameAccountsLandingPageSubHeader:
      'Please select the account you want to rename.',
    renameAccountHeader: 'Rename account',
    renameAccountSubHeader:
      "Personalise your account by giving it a nickname. This is what your account will be called on internet banking and our mobile app. It'll only be visible to you and it won't be called this on things like statements or cheque books.",
    renameAccountSuccess: 'Account name has been updated',
    renameAccountRestore: 'Change back to original account name',
    renameAccountNickname: 'Account nickname',

    // sweeps
    sweepLine1: 'In my',
    sweepLine2: 'when I have <strong>less</strong> than',
    sweepLine3: '<strong>sweep</strong> money from',
    sweepLine4: 'to meet my target of',
    triggerEntryViewController_TermsOfUse_SingleAccount:
      'You can set up Sweeps to move money from your B Instant Savings account to your B Current Account. They can help you avoid charges but remember, they’re just automatic transfers, so will only work if there is enough money in your B Instant Savings account - e.g. you can set up a 					Sweep to add £150 to your B Current Account every time it gets below £50 but it will only sweep that if you have the £150 in your B Instant Savings account. Make sense? They can take a teeny bit of time to show on your account but you’ll get a text each time a Sweep happens, 				even if it’s at the weekend. And you can change your Sweep settings at any time.',
    infoPopupContentForJointAccountHolder:
      'Low balance sweeps are automatic transfers from our chosen B Instant Savings account to our joint B Current account. One of us can set up sweeps to avoid charges and make payments when my current account runs low (drops below the lower balance trigger)										  .However, sweeps can only work if there is enough money in our chosen savings account. If there isn’t, the sweep may not be able to reach the joint account’s lower target balance and the account will be charged. Sweeps can happen several times a day 										  (including weekends).\n\nEvery time there’s a sweep both joint account holders will get a text to let them know what’s happening. Likewise when one of you edits sweep settings, both joint account holders will be made aware of the change.',
    infoPopupContent:
      'Low balance sweeps are simply automatic transfers from my B Instant Savings account to my B Current account. I can set up sweeps to avoid charges and make payments when my current account runs low (drops below my lower balance trigger). However, sweeps can only work if there is enough money in my savings account. If there isn’t, the sweep may not be able to reach my lower target balance and I may have to pay charges. Sweeps can happen several times a day (including weekends). Each time there’s a sweep I’ll get a text to let me know what’s happening. I can change the settings any time I like within B.',
    infoPopupContentForJointAccount:
      "Either of you can set up Sweeps to move money from your B Instant Savings Account to your B Current Account. They can help you avoid charges but remember, they're just automatic transfers, so will only work if there is enough money in your B Instant Savings account – e.g. you can set up a Sweep to bring your balance up to £150 in your B Current account every time it gets below £50, but it will only sweep that if you have enough money in your B Instant Savings account. Make sense? They can take a teeny bit of time to show on your account but both of you will get a text each time a Sweep happens, even if it's at the weekend. And you can change the Sweep settings any time you like, so long as it's sweeping money from one of your own accounts - we'll let you both know if this happens.\n",
    infoPopupHeader: 'User agreements',
    infoPopupButton: 'OK, I understand',
    deletePopupHeader: 'Delete',
    deletePopupContent: 'Are you sure you want to delete this sweep?',
    okButton: 'OK',
    deleteSweep: 'Delete Sweep',
    sweepCreationPopup: 'Your sweep has been created',
    sweepUpdatePopup: 'Your sweep has been updated',
    sweepDeletePopup: 'Your sweep has been deleted',
    sweepNotDeletePopup: 'Sweep not found',
    doneButton: 'Done',
    editMySweep: 'Edit my sweep',
    createMySweep: 'Create my Sweep',
    createMySweepNewUser: 'Create a sweep',
    OK: 'OK',

    // Alerts&Sweeps page
    createMyAlert: 'Create my Alert',
    alertSweepTitle: 'Alerts',
    alertsSweepsHead: 'Alerts',
    wbaMessage:
      "Keep track of your money with weekly text updates that tell you how much you've got left in your account.",
    alertMessage:
      'Set up alerts to receive text messages when you reach a certain amount on your chosen account.',
    sweepMessage:
      'Set up sweeps to be notified when your threshold is reached and select the account you want your money to be swept from to meet your target balance.',
    alerts: 'Alerts',
    wba: 'Balance updates',
    errorMessage: 'Something techie has gone wrong. Please try again.',
    cancelButton: 'Cancel',
    confirmButton: 'Confirm',
    confirmButtonSweep: 'Create sweep',
    confirmButtonAlert: 'Create alert',
    confirmButtonUpdate: 'Create alert',
    infoButton: 'Info',
    deleteButton: 'Delete',
    createSweep: 'Create sweep',
    createUpdate: 'Create a weekly balance update',
    editMyUpdate: 'Edit my weekly balance update',
    editSweep: 'Edit Sweep',
    createAlert: 'Create alert',
    AlertSweep: 'Alert',
    footerLabelSweep:
      'Just so you know, you might still get one more balance sweep from us.',
    footerLabelAlert:
      'Just so you know, you might still get one more balance alert from us.',
    footerLableWBA:
      'Just so you know, you might still get one more alert from us.',
    footerLabelJointAccountHolder:
      'This sweep was set up by your joint account holder. You can’t edit it, but you can give them a nudge to do it',
    maxSweepPopupHeader: 'An alert about your sweeps',
    maxWBAPopupHeader: 'Your balance updates',
    maxSweepPopupData:
      'You can only have one low balance sweep per account. But you can edit your existing sweeps.',
    appErrorForAlerts: 'We were unable to load your alerts at this time.',
    //	triggerDashboardViewController_Failure_Details_Text: 'We were unable to load your alerts at this time. Please try again later',
    //	failedToLoadSweeps: 'We were unable to load your sweeps at this time. Please try again later',
    //	failedTpLoadAlertsNSweeps: 'We were unable to load your alerts or sweeps at this time. Please try again later',
    triggerDashboardViewController_NoEligibleAccounts_Title:
      'No available accounts', // not used
    triggerDashboardViewController_NoEligibleAccounts_Alerts:
      'To use alerts, you need to open an account which supports them.', // not used
    triggerDashboardViewController_NoEligibleAccounts_Sweeps:
      'To use sweeps, you need to open an account which supports them.', // not used
    triggerDashboardViewController_NoEligibleAccounts_AlertsSweeps:
      'To use alerts you need to open an account which supports them.', // not used
    triggerDashboardViewController_NoEligibleAccounts_ButtonTitle: 'Retry', // not used
    triggerDashboardViewController_CantCreateTrigger_Title:
      'Server unavailable', // to ask
    triggerDashboardViewController_CantCreateTriggerAlert_Message:
      'Can’t create any alert', // to ask
    triggerDashboardViewController_CantCreateTriggerSweep_Message:
      'Can’t create any sweep', // to ask
    triggerEntryViewController_ThresholdAmount_Minimum_Error_Message:
      'Threshold amount has to be at least 0 pounds.', // to ask
    triggerEntryViewController_TargetAmount_Minimum_Error_Message:
      'Target amount has to be at least 100 pounds.', // to ask
    triggerEntryViewController_TargetAmount_Error_Message:
      'Target amount has to be at least 100 pounds larger than the threshold amount.',
    triggerListCell_lowerThresholdAlert_Title_Prefix: 'Low balance alert',
    triggerListCell_projectionThresholdAlert_Title_Prefix:
      'Projection low balance alert', // differ
    triggerListCell_upperThresholdAlert_Title_Prefix: 'High balance alert',
    triggerEntryViewController_ending: 'ending',
    projectionLowBalanceAlert: 'Projection balance Alert', // removed low word
    sweepAlert: 'Sweep alert',
    jointAccountHolders: 'Joint Account Holders',
    confirmChanges: 'Confirm changes',
    // projectionInformation :'When I am projected to have <strong>{lessMore}</strong> than <strong>£{thresholdAmount}</strong> in my <strong>{accountName}</strong> please send me a text.',
    // WBA
    createAnUpdate: 'Create a balance update',
    wbaTitle: 'Weekly balance update',
    // Alerts
    alertLandingPage: 'Manage your alerts',
    alertSweepValidationMsg:
      'Sorry, you’ll have to enter an amount here to continue.',
    alertCreationPopup: 'Your alert has been created',
    alertUpdatePopup: 'Your alert has been updated',
    createMyAlertNewUser: 'Create an alert',
    editMyAlert: 'Edit my alert',
    inMy: 'In my',
    whenIHave: 'when I have',
    than: 'than',
    send: '<strong>send</strong> me an alert via',
    sms: 'SMS',
    maxAlertPopupHeader: 'An alert about your alerts',
    maxAlertPopupData:
      'You can only have one high and one low balance alert per account. But you can edit your existing alerts.',
    maxWBAPopupData:
      'You can only set up one weekly balance update per account. But you can go ahead and edit your existing balance updates if you need to.',

    // Payment Thank you page
    trnasferOneOff: 'Transfer complete',
    paymentSuccesHeadingSO: 'Transaction scheduled',
    paymentSuccesHeadingOneOff: 'Payment submitted',
    paymentSuccesSOFooterTomorrow: 'The first transaction will be made ',
    paymentSuccesSOFooterDate: 'The first transaction will be made on ',
    paymentSuccesFDPFooterTomorrow: 'This will be made',
    paymentSuccesFDPFooterDate: 'This will be made on ',
    scheduledFooter: '',
    paymentSuccessSubHeaderFDP:
      'Your {amount} transaction to {payeename} has been scheduled.',
    paymentSuccessSubHeaderSO:
      'Your repeating transaction of {amount} to {payeename} has been scheduled.',
    paymentSuccessSubHeaderOneOff:
      'Your payment for <strong>{amount}</strong> has been sent to <strong>{payeename}</strong>.',
    transferSuccessSubHeaderOneOff:
      'Your transfer to <strong>{payeename}</strong> for <strong>{amount}</strong> has been successful.',

    // Payment page
    nicknameHintText: 'Only you’ll see this.',
    accountNameHintText:
      'This is the name of the person who holds the account with this business',
    fraudTitle: 'Protect yourself from fraud and scams',
    fraudIntro1:
      'Your bank and other trusted organisations will never ask you to move your money - but scammers will.',
    fraudIntro2:
      'So before you add this payee and send your money, take some time to stop and think:',

    fraudQuestions: [
      "Is someone you don't know pressurising you to make this payment?",
      'Have you been contacted by someone requesting you to move or transfer money to another account?',
    ],
    fraudRecovery:
      "If you make a payment to this payee and it turns out to be a scam, it's unlikely your money will be recovered. So if you're not sure, don't risk it.",
    fraudMoreInformation1: 'For more information, visit the',
    fraudMoreInformation2: 'on our website',
    fraudMoreInformationLinkUrl:
      '/personal/ways-of-banking/help-and-support/security',
    fraudMoreInformationLinkName: 'security section',
    fraudConfirm:
      "By ticking this box you confirm you're happy to add this payee and proceed with payments to them.",
    managePaymentLink: 'Manage your payments',
    paymentLink: 'Payment',
    transferLink: 'Transfer',
    transFrom: 'Transfer from?',
    transTo: 'Transfer to?',
    managePayeeLink: 'Manage your payees',
    fromTitle: 'From',
    toTitle: 'To',
    payFrom: 'Paying from?',
    howMuchTitle: 'How much?',
    currentTitle: 'current',
    available: 'available',
    newPayeeLink: 'Pay someone new',
    subHeaderContent:
      "Choose <strong>'Person'</strong> to manually enter the payment details of the person or business you want to pay or <strong>'Company'</strong> to search for large organisations like credit card companies and local authorities - this can come in useful when you have to pay a bill or invoice.",
    reference: 'Reference',
    accountHolderName: 'Account holder name',
    when: 'Date',
    repeatPayment: 'Repeat this',
    repeatPaymentText: 'Repeat this payment?',
    howOften: 'Frequency',
    startDate: 'Start date',
    stopitWhen: 'Stop it',
    pickdate: 'On a set date',
    noOfTimes: 'After a set number of times',
    ending: 'Ending',
    Weekly: 'Every week',
    twoWeekly: 'Every 2 weeks',
    threeWeekly: 'Every 3 weeks',
    fourWeekly: 'Every 4 weeks',
    monthly: 'Every month',
    twoMonthly: 'Every 2 months',
    threeMonthly: 'Every 3 months',
    sixMonthly: 'Every 6 months',
    anually: 'Every year',
    archivedPaymentsHead: 'Archived payments',
    archivedPaymentAll: 'All',
    payments: 'Payments',
    transfers: 'Transfers',
    directDebits: 'Direct debits',
    back: 'Back',
    archived: 'Archived',
    managePaymentTitle: 'Manage your payments',
    managePayee: 'Manage Your Payee',
    cancel: 'Cancel',
    accountLabel: 'Account',
    lastAmount: 'Last Amount',
    lastPayment: 'Last Payment',
    type: 'Type',
    status: 'Status',
    accountNumber: 'Account number',
    sortCode: 'Sort code',
    editSortCode: 'Sort Code',
    amount: 'Amount',
    nextDue: 'Due',
    paid: 'Paid',
    done: 'Done',
    delete: 'Delete',
    managePayments: 'Manage your payments',
    addPayeeContent: 'Pay someone new',
    editPayeeContent: 'Edit Payee',
    payeeName: 'Payee name',
    payeeSortCode: 'Sort code',
    payeeOrbill: 'Is it a bill or person',
    payeeAccountNumber: 'Account number',
    payeeReference: 'Reference',
    payeeNickName: 'Nickname',
    NAME: 'name',
    DELETE_PAYMENT_TYPE: 'DELETE_PAYMENT',
    chooseDate: 'Choose a date',
    schedule: 'schedule',
    end_condition: 'end_condition',
    person: 'Person',
    nameOfThePerson: 'Name on account',
    nameOfThePersonHelpText:
      'We’ll ask their bank if the name matches what you’ve entered. You only need one name for a joint account.',
    nameOfTheCompany: 'Business name',
    nameOfTheCompanyHelpText:
      'We’ll ask their bank if the name matches what you’ve entered. Trading names might not match - an invoice should show the account name.',
    theirSortCode: 'Sort code',
    theirAccountNo: 'Account number',
    ReferencePayeeText: 'Helps you and the payee recognise the payment.',
    addPayeeCheckboxText1: 'Save in payee list',
    addPayeeCheckboxText2:
      'Save time and hassle when making and authorising payments to this payee.',
    addPayeeMoreInfoText:
      'Keep these details so you don’t have to enter them again and again. Saving this payee in your secure payee list could also help reduce the steps required to authorise future payments to them (payment approval limits will still apply).',
    addPayeeNickName: 'Nickname',
    addPayeeNickNameText1:
      'Allows you to use an alternative name for the payee. This will appear within online banking but',
    addPayeeNickNameText2: ' not on your statements.',
    bill: 'Bill',
    noOfTime: 'noOfTime',
    noOfTimeValidationMessage: 'Number of time should be of 2 digit or less',
    addPayee: 'Continue',
    addNewPayeeBack: 'Your payment contacts',
    addNewPayeeHeader: 'New payment contact',
    saveDetails: 'Save in payee list',
    payeeRequestPacket_Name: 'name',
    nameValidationMessage: 'Please use letters and spaces only.',
    payeeRequestPacket_account_id: 'account_id',
    payeeRequestPacket_sort_code: 'sort_code',
    sort_codeValidationMessage: 'Sort Code should be a 6 digit number',
    payeeRequestPacket_account_number: 'account_number',
    account_numberValidationMessage:
      'Account Number should be a 12 digit number',
    payeeRequestPacket_reference: 'reference',
    payeeRequestPacket_account_name: 'account_name',
    referenceValidationMessage: 'Invalid Reference',
    payeeRequestPacket_single_use: 'single_use',
    payeeRequestPacket_nick_name: 'display_name',
    display_name: 'display_name',
    nick_nameValidationMessage: 'Nick Name should not have special character',
    deleteBeneficiary: 'Delete Beneficiary',
    deletePayment: 'Delete payment contact',
    editPaymentText:
      'Your Payment has been edited, but the changes could take until tomorrow (or the next working day) to appear.',
    deletePaymentText:
      'Your Payment has been cancelled, but might still appear until tomorrow (or the next working day).',
    ok: 'OK',
    okButtonText: 'OK',
    beneficiary_id: 'beneficiary_id',
    DELETE_PAYEE_TYPE: 'DELETE_PAYEE',
    placeHolderContent: "Don't Forget",
    creditPopUpHeader: 'Please be aware...',
    creditPopUpBody:
      "If you use your credit card, there will be a cash advance fee to pay of 3% (min £3). The cash advance interest rate will also apply as per your credit card agreement. Are you sure that's OK? For further information please call the team on 0800 121 7 365.",
    deletePayeePopUp: 'Are you sure you want to delete <br/> this beneficiary?',
    deletePayeePopUpmobile: 'Are you sure you want to delete this beneficiary?',
    AmountValidationMessage: 'Invalid Amount',
    mandateTypeDD: 'dd',
    mandateTypeSO: 'so',
    paymentContactTitle: 'Your payment contacts',
    nickName: 'NickName',
    viewDetails: 'View Details',
    thankYouText: 'Thank You',
    regularPayment: 'Your payment for ',
    regularTransfer: 'Your transfer to ',
    paymentThroughText: 'has gone through for',
    thankYouFooterText:
      'Please allow until tomorrow or the next working day for it to appear.',
    cancelTitle: 'Cancel',
    sureTitle: 'Are you sure?',
    active: 'Active',
    inactive: 'Inactive',
    single_use: 'single_use',
    account_Id: 'account_Id',
    edit: 'Edit',
    errorHeader: 'Error',
    eligibleErrMsg:
      'you cannot make an internal transfer because you have less than two elligible accounts',
    errorButton: 'OK',
    whenIcancel: 'When I cancel it',
    endDate: 'Stop it on',
    howManyTimes: 'Number of times',
    makePayment: 'Make Payment',
    makeTransfer: 'Make Transfer',
    loadingPaymentText: 'Loading payments data.....',
    isRepeat: 'Yes',
    confirmCancel: 'Confirm Cancel?',
    confirmCancelWeb: 'Confirm cancellation',
    accountName: 'Name',
    managePaymentFooter:
      "That's all of them. Any new payments you make will appear here.",
    archivedPaymentFooter:
      "That's all of them. Any archived payments will appear here.",
    editpopupStartText:
      "These changes only apply to this person or company for future payments.  If you are already paying them with a direct debit or standing order, you need to update that to the new details you've just saved.",
    editpopupEndText:
      "If you've got this person saved as a payee somewhere else outside B, for example in Clydesdale or Yorkshire Bank internet banking, you'll need to update that separately too.",
    cancelThisTransfer: 'Cancel this Transfer',
    cancelThisTransferweb: 'Cancel this transfer',
    cancelThisPayment: 'Cancel this Payment',
    NextButton: 'Next',
    continueButton: 'Continue',
    Yes: 'Yes',
    No: 'No',
    editManagePayment: 'Edit payment',
    managePayment: 'Manage payment',
    managePaymentHeader: 'Manage payment',
    allDoneMessage: 'Payment edited',
    toolTipMessageComplexSO:
      "This payment can't be edited online. If you need to make changes to this payment, please give us a call or visit your local branch.",
    unAllocatedHeader: 'Your Savings Pots are currently overallocated.',
    unAllocatedContent: 'Please take action to correct this immediately',
    availBalance: 'Available balance',
    amountValidationError:
      "You can't transfer more money out of a pot than is actually in it.",
    loadingPayeeText: 'Payee list loading...',
    someoneNewText: 'Someone new?',
    amountError: 'Cannot enter amount greater than available amount',
    oneOffPaymentText: 'Make a one-off transfer between your accounts',
    oneOffReapetPaymentText: 'Set up a regular transfer',
    thankOneOffRepeatText:
      'Please allow until tomorrow or the next working day for it to appear',
    setUpRegularTransfer: 'Set up a regular transfer',
    potMessage:
      "This payee can't set up standing orders or future-dated payments. If you choose it, you will only be able to make an single payment. Is this OK?",
    payingTo: 'Paying to?',
    whenHappen: 'When would you like this to happen?',
    whenGo: 'When do you want it to go through?',
    loadingAccounts: 'Loading Accounts...',
    referenceText: 'Enter Reference',
    potsLoading: 'Saving pot loading....',
    payeeRef: 'Ref',
    noPayeeMsgFirstLine: "Oops! You don't have anyone set up yet.",
    noPayeeMsgSecondLine:
      'Go back to the Payment screen and hit "Someone new?"',
    chooseValue: 'Choose a value',
    paymentText: 'Your payment for ',
    lastPaymentReference: 'Last Payment Reference',
    transferText: 'Your transfer to ',
    validationHead: 'By the Way',
    validationMsg:
      "It's not possible to process a payment after 4pm on the previous working day.",
    PayeeAccountNumber: 'Number',
    referenceNumberText:
      'A note to help you remember why you moved this money. This will appear in your transactions list and statement.',
    repeatingPaymentText:
      "Choose <strong>'One-off'</strong> to move this money just once or <strong>'Repeating'</strong> if you want to set up a standing order.",
    paymentFrequencyText: 'Payment type',
    oneOffPayment: 'One-off',
    repeatingPayment: 'Repeating',
    datePickerText: '',
    madePaymentText: 'has been made.',
    for: 'for',
    paymentSuccess: 'Success. Your payment will clear within 2 hours.',
    goToAccountsText: 'Go to your accounts',
    makeAnotherPaymentText: 'Make another payment or transfer',
    endDatePickerText:
      'Use the date picker to select when you want the repeating payment to stop. Alternatively, enter it in the format DD/MM/YYYY.',
    newPayee: 'Your payees',
    csrText: 'Current savings interest rate <strong>amount% AER</strong>',
    savingspotTileText: 'Make saving as easy as spending.',
    savingspotTileBtnLabel: 'Go to Savings Pots >',
    addCompany:
      'If the company you want to pay is on our database, we’ll fill in their payment details for you. And if their details ever change in the future, they’ll be updated automatically.',

    payNew: 'Add a new payee',
    display_nameErrorMessage: 'Please enter a nickname for this payee',
    downloadMobileAppForSoftTokenText:
      '<p>To continue with this <payment>, you’ll have to authorise it using one of our online security methods – or go back and reduce the amount you’re trying to move.</p><p>The quickest way to authorise payments is to download our mobile banking app. Simply search for <strong>‘Clydesdale Bank Mobile Banking’</strong> on the Apple App Store or Google Play Store, set the app up then come back to finish moving your money.</p>',
    knowMoreText:
      'To find out more about authorising payments, including other authorisation options, please get in touch or visit the FAQs in the help section.',
    reduceAmountButton: 'OK',
    goGetBText: 'Close this window and download the app',
    softTokenErrorHeading: 'Authorise this <payment>',

    // Error page text
    errorText1: 'Sorry, there’s been a technical problem',
    errorText2: 'It looks like something has gone wrong in the background.',
    errorText3:
      'Please log out then log back in to try again. If you’re still having problems, please get in touch.',
    // Business Product
    businessProducts: 'Flexible business banking products',
    businessProductsContent:
      'Reliable business banking to help simplify your finances',
    businessProductsContent1:
      "Keeping on top of your business finances is crucial. But it's not always easy, and it can be time consuming for small business owners. We're here to help make it easier.",
    businessProductsContent2:
      'From everyday transactions and savings to growth finance and insurance, we could help make it all that little bit easier. All products and services are subject to status and eligibility.',
    productHeadErrorMessage:
      'We were unable to load your products at this time.',
    productBodyErrorMessage: '',
    // Products

    productPageTitle: 'ProductsPage',
    products: 'Products',
    productsContent:
      'We hope to provide you with a full service at Clydesdale Bank &#45 giving you access to many different products that will help you manage your money. Within this range, fees and charges may apply. All credit facilities are subject to status and security may be required on a number of products. Age restrictions may also apply.',
    linkText:
      'These links will open the main website in another window. If you do not return to Internet Banking within 5 minutes, you will be logged out.',
    logOutWarningText:
      'If you do not return to Internet Banking within 5 minutes, you will be logged out.',
    productsModelContent:
      'You have selected to move out of internet banking. If you do not return within 5 minutes you will be automatically logged out.',
    productsModelNonBProductContent:
      'B is powered by XXXXX bank. The product you have selected is available from them. We will take you to the website in a new browser window to view the details.<br><br> If you do not return to this browser window within 5 minutes you will be automatically logged out.',
    modalHeading: 'Opening in new window',
    modalFooter: '',
    productsFooterText:
      'Your home may be repossessed if you don’t keep up repayments on your mortgage',
    cancelButtonText: 'Cancel',
    continueButtonText: 'Continue',
    nonBContinueButtonText: 'Continue to XXXXX website',
    activateHardTokenHeading: 'Activate security token',
    activateHardTokenDescription:
      'Activate your token now to get even more protection when you bank online.',
    activateHardTokenLink: 'Activate it',

    // virgin money loans merged with CB YB B
    loansModalHeading: 'We’ve joined forces with Virgin Money',
    loansModelContent1:
      'Clydesdale Bank, Yorkshire Bank and B have teamed up with Virgin Money to become one bigger, better and brighter bank.',
    loansModelContent2:
      'So if you continue with a loan application, you’ll be applying for a Virgin Money loan.',
    loansModelContent3:
      "With a Virgin Money loan, you’ll get the best of both worlds. Clydesdale and Yorkshire Bank's experience and Virgin's forward-thinking innovation. It’s the perfect bank balance.",
    loansModelContent4:
      'That’s enough about us. Let’s get going and help make your plans a reality.',
    loansContinueButtonText: 'OK, got it',
    // SO DD Diffrence Modal changes
    DDSOModalTextHeader:
      'What’s the difference between a Direct Debit and a standing order?',
    DDDefinition:
      "A <strong>Direct Debit</strong> is a repeating payment set up by the company you’re making payments to. Normally, you’ll have signed a mandate that gives them permission to take funds from your account in an agreed way - like a monthly gym membership or your mobile phone bill. With a Direct Debit, you're protected under the Direct Debit Guarantee scheme, so any amount debited in error is refunded immediately.",
    SODefinition:
      'A <strong>standing order</strong> is a repeating payment you’ve set up yourself to pay other people or organisations or to transfer money between your own accounts.',
    DDSOInfo:
      "You can edit or cancel standing orders as and when you like. But if you want to change a Direct Debit, you’ll have to contact the company you're paying to make the changes for you.",
    DDSOModalClose: 'OK',

    refErrorMsgManagePayments: 'Please enter a reference for this payment.',
    referenceErrorMsgMoveMoneyTransfer: 'Please enter a reference.',
    amountErrorMessage: 'Please enter the amount you want to pay.',
    futureDateErrorMessage:
      'Please select the date you want the next payment to come out. This should in the format DD/MM/YYYY.',
    nextDateErrorMessage:
      'Please select the date you want the next payment to come out. This should in the format DD/MM/YYYY.',

    // Chat tile Display Messages
    chatHeading: 'Live chat',
    chatDescription:
      'We’ll keep chat transcripts for training, legal and compliance purposes.',
    genericChatSubheading:
      'Open live chat now to talk to one of our advisors online.',
    // Generic Chat Tile Display Messages
    genericChatHeading: 'Need help? Chat to us',
    genericChatDescription:
      'The Virgin Money team will keep chat transcripts for training, legal and compliance reasons.',
    genericChatButtonText: 'Launch live chat',

    // DDSOModalClose: 'OK',

    toolTipMessageDD:
      'If you want to make changes to a Direct Debit, you’ll have to contact the organisation you’re paying to make them for you. You can cancel a Direct Debit on your own at any time but remember to let the company know so they don’t try to take money out your account.',
    cancelDDInfo:
      'You’re about to cancel the following Direct Debit. Before you do this, we recommend you let the organisation you’re currently paying know so they don’t try to take the money out your account.',
    after4pmMessage:
      'One-off payments can be cancelled up to midnight on the business day before the payment is due to leave your account, for repeating standing orders it’s 4pm the business day before. If you cancel after this time money may still leave your account.',
    after4pmMessageDD:
      'You can cancel this up to 4pm on the business day before it’s due to be paid. If you cancel it after this time, the payment may still be taken.',

    cancelledFooter: 'Any archived payments will appear here.',

    // order paper statement.
    helmetTitlePaper: 'Order a paper statement',
    titlePaper: 'Order a paper statement',
    mainDescriptionPaper:
      'Did you know that online statements are now available on internet banking and our mobile banking app?',
    subDescriptionPaper:
      'You can view your statements whenever you need them. And you can download and print them straight from your mobile, tablet or computer. It’s simple, secure and convenient.',
    linkNamePaper: 'View, download or print an online statement',
    orderButtonNamePaper: 'Order now',
    modelTitlePaper: "Your statement's on its way",
    subContent1: 'If you need a paper copy of your statement, please ',
    callUsText: 'give us a call. ',
    subContent2:
      'We’ll send your statement to your registered address within 7–10 business days.',
    // order cheque book
    helmetTitleCheque: 'Order a new cheque book',
    titleCheque: 'Order a new cheque book',
    mainDescriptionCheque:
      'If you’ve already had a cheque book for this account in the past, you can order a new one right here. We’ll send it to your registered address within 7–10 business days.',
    subDescriptionCheque:
      'Please give us a call and we’ll get one ordered for you.',
    subTitleCheque: 'Never had a cheque book before?',
    orderButtonNameCheque: 'Order now',
    modelTitleCheque: 'Your cheque book’s on its way',
    modelBodyContentCheque:
      'Your new cheque book will be delivered to your registered address within 7–10 business days.',
    modelOkButtonCheque: 'OK',
    // order payin
    helmetTitlePayin: 'Order a new pay-in book',
    titlePayin: 'Order a new pay-in book',
    mainDescriptionPayin:
      'If you’ve already had a pay-in book for this account in the past, you can order a new one right here. We’ll send it to your registered address within 7–10 business days.',
    subDescriptionPayin:
      'Please give us a call and we’ll get one ordered for you.',
    subTitlePayin: 'Never had a pay-in book before?',
    orderButtonNamePayin: 'Order now',
    modelTitlePayin: 'Your pay-in book’s on its way',
    modelBodyContentPayin:
      'Your new pay-in book will be delivered to your registered address within 7–10 business days.',
    modelOkButtonPayin: 'OK',
    // cma

    alertAccountPageHeading: 'Manage your alerts',
    alertAccountPageDescription:
      'Our useful text alerts help you manage your money and stay in control. Please select what account you want to manage the alerts for.',
    alertAccountPageFooterDescription:
      'Alerts are currently only available for the accounts shown above.',
    alertListHeading: 'Manage your alerts',
    alertListDescription:
      'Alerts are currently only available for this account.',
    alertListCMAHeading: 'Take action alerts',

    alertListCMASubHeading:
      'Send me a text when I don’t have enough money in my account to cover a payment or if a payment takes me into unarranged overdraft.',
    alertListCMAMoreButtonName: 'Find out more',
    alertListCMASubDescription:
      'Take action alerts will let you know when you’ll have to pay money in to your account for payments to go through or to avoid an unarranged overdraft and possible charges. You can turn these alerts off at any time.',
    alertListCustomAlertHeading: 'Custom alerts',
    alertListWBHeading: 'Weekly balance update',
    alertListWBcontentDesc: 'Send me a text every',
    alertListWBContentSubDec: 'to let me know how much I’ve got in my account.',
    alertListHighAlertHeading: 'High balance alert',
    alertListHighAlertContentDesc:
      'Send me a text when my available balance goes above',
    alertListHighAlertContentSubDesc: '.',
    alertListLowAlertHeading: 'Low balance alert',
    alertListLowAlertContentDesc:
      'Send me a text when my available balance goes below',
    alertListLowAlertContentSubDesc: '.',

    alertWBHeading: 'Weekly balance update',
    alertWBSubHeading:
      'Send me a text to let me know how much I’ve got in my account every',

    alertHighBalanceHeading: 'High balance alert',
    alertHighBalanceSubDesc:
      'Send me a text when my available balance goes above',

    alertLowBalanceHeading: 'Low balance alert',
    alertLowBalanceSubDesc:
      'Send me a text when my available balance goes below',

    cancelButtonName: 'Cancel',
    confirmButtonName: 'Confirm',

    // Account Reorder
    eGainChatModelHeader: 'Opening in new window',
    eGainChatModelText:
      'Our live chat tool will open up in a new window. If you’re busy chatting to one of our advisors and don’t use internet banking within the next 5 minutes, you’ll be automatically logged out.',
    eGainChatModelButtonText: 'OK, chat now',
    accountReorderHeader: 'Change account order',
    accountReorderHeader1:
      'This is the order your accounts will appear within internet banking.',
    accountReorderFavouritesHeader:
      'This is the order your favourite accounts will appear within Business Internet Banking.',
    accountReorderAddFavourites:
      'You can only change the order of accounts you’ve marked as favourites.',
    arrowButtonsUseTip:
      'Change the order of your accounts using the arrow buttons below.',

    clearedBalance: 'Cleared balance',
    isaTaxYearDisplayText: 'Subscriptions made so far this tax year',
    isaTotalDepositDisplayText: 'Maximum annual allowance remaining',
    isaTaxYearDepositExplanationText:
      'This amount is the net amount of all deposits and withdrawals to and from this cash ISA in this tax year. To find out more about ISA limits and rules, please visit our ',
    isaTotalDepositExplanationText:
      'This amount is solely based on the deposits and withdrawals you’ve made into or taken from this cash ISA. If you’ve made deposits into other types of ISAs this tax year, you may not have as much as this remaining. To find out more about ISA limits and rules, please visit our ',
    // Payment SME Contents
    paymentSMEHeader: 'Pay or transfer money',
    paymentSMESubHeader:
      'Pay a bill, person or organisation or transfer money between your accounts. You can save time by setting up repeating transactions or making multiple payments and transfers at the one time.',
    paymentSMEUnauthorisedSubHeader:
      'You don’t have permission to make payments and transfers. Please contact your corporate administrator for more information',
    multiplePaymentQuickLink: 'Make multiple payments',
    smeReviewWarningHeader: "Your payment hasn't been made yet",
    smeReviewWarningBody:
      "If you leave this page now, your transaction won't be completed.",
    leaveThePage: 'Leave page',
    continueWithPayment: 'Continue with payment',
    paymentCOPUrl: 'https://uk.virginmoney.com/service/cop/',

    // Secure Message
    communicationsHub: 'Communications Hub',
    secureMessages: 'Secure messages',
    youGot: "You've got ",
    newSecureMessages: ' new secure messages',
    oneSecureMessage: ' new secure message',
    messageTitle: 'Message us',
    messageContent:
      'Securely share your details and get all the help you need. It’s simple, safe and secure.',
    newSecureMessage: 'Secure messaging',
    leaveMessageUsTitle: "Your message hasn't been sent yet",
    leaveMessageUsBody:
      "If you leave this page now, your message won't be sent or saved as a draft.",
    leaveMessageUsPrimaryButtonText: 'Continue with message',

    // Secure Message Lets chat Modal
    letsChatModalTitle: "Looking for help? Let's chat",
    youCanSendMessage:
      'You can now send and receive secure messages in a flash with our new instant message service.',
    manyCustomersAreUsingMsg:
      'Many customers are already getting help and advice right away, just by selecting Let’s chat.',
    withLetsChatMsg: 'With Let’s chat, you can:',
    withLetsChatDescList: {
      getInTouchMsg: 'Get in touch day or night',
      getAnInstantReplyMsg: 'Get an instant reply',
      manageYourAccountMsg:
        'Manage your account and chat with us at the same time',
    },
    easyToUseMsg:
      "It’s easy to use, and you’ll still be able to access the current service as normal. Just remember, you won't see your old secure messages in Let’s chat.",
    continueToSecMsgBtnTxt: 'Continue with secure messaging',
    letsChatBtnTxt: 'Let’s chat',
    dontShowAgainMsg: 'Don’t show this again',

    // Fate of payment content
    quickLinkPaymentStatus: 'Payments status and history',
    paymentHistoryToolTipMessage:
      'The payments list only shows payments you’ve made within mobile and internet banking. It doesn’t include transactions you’ve made with your debit card, for example, or Direct Debits taken by companies. You can view these in your transaction list on the account page.',
    paymentHistoryListHeader: 'Payment List',
    paymentHistoryNoDataMsg: 'No Payments Found. Try changing your date range.',
    paymentHistoryMobileNoDataMsg:
      'No Payments Found. You can only see your last three months payments using your mobile device.',
    paymentHistoryFilterFromErrorMsg:
      'Something’s not right there. Make sure the date you’ve entered is less than 13 Months ago and before the date you want to view your payments up to',
    paymentHistoryFilterToFieldErrorMsg:
      'Something’s not right there. Make sure the date you’ve entered isn’t in the future or before the date you want to view your payments from',
    smePaymentHistoryFilterFromErrorMsg:
      'Something’s not right there. Make sure the date you’ve entered is less than 18 Months ago and before the date you want to view your payments up to',
    paymentHistoryFooterMsg:
      'That’s all we can find. Try changing your date range.',
    paymentHistoryMobileFooterMsg:
      'That’s all we can find. You can only see your last three months payments using your mobile device.',
    showMore: 'Show More',
    ibanAndBicInfo:
      'If someone’s sending you money from abroad, you’ll have to give them your IBAN (International Bank Account Number) and BIC (Bank Identifier Code) to receive your payment.',
    authorisationAlertSingularMsg: 'You’ve got a ',
    authorisationAlertPluralMsg: 'You’ve got ',
    authorisationAlertSingularAnchorBody: 'payment to authorise.',
    authorisationAlertPluralAnchorBody: 'payments to authorise.',
    accountPickerLabel: 'Accounts',
    searchPaymentHistoryEmptyMsg:
      'No payments found. Try changing your search criteria.',
    paymentHistoryNoTransactionMsg:
      'No payments found. Try changing your date range or payment status',
    // Dispute payments
    pendingPaymentTitle: 'The payment is pending',
    pendingPaymentText1:
      "If it's been pending for more than 5 days, contact the seller to see what's going on.",
    helpWithPaymentTitle: 'Help with this payment',
    helpWithPaymentCancelTitle: 'I want to cancel the payment or get more info',
    helpWithPaymentCancelText:
      'Our digital host, Redi, can help you if you have questions about this payment.',
    helpWithPaymentFraudTitle: "I didn't make this payment",
    helpWithPaymentFraudText:
      'If you think someone else made this payment, it could be fraud. We can help to make sure your account is secure.',
    helpWithPaymentDisputeTitle: "I made this payment but there's a problem",
    helpWithPaymentDisputeText:
      "For example, if you haven't received what you've paid for or you've been charged the wrong amount.",
    helpWithPaymentDisputeModalTitle: 'Dispute this payment',
    helpWithPaymentDisputeBodyBold:
      "If there's a problem with something you've paid for, and you can't work things out with the seller, you can dispute the payment.",
    helpWithPaymentDisputeTicklistTitle1:
      'We can try to get your money back if:',
    helpWithPaymentDisputeTicklist1: [
      "You haven't received what you paid for",
      "You've been charged the wrong amount",
      'You receieved something that was damaged or not as described',
      "You haven't recieved a refund when you were supposed to",
    ],
    helpWithPaymentDisputeTicklistTitle2:
      'We can try to get your money back if:',
    helpWithPaymentDisputeTicklist2: [
      "It's still a pending payment",
      "You haven't given the seller a chance to make things right",
      "The expected delivery date hasn't passed yet",
      "The payment wasn't made on your debit card",
    ],
    callPaymentTitle: 'Give us a call',
    callPaymentText1:
      "If you've been overcharged, you can claim anytime up to 90 days after the goods or services should have been delivered.",
    callPaymentText2:
      "We'll need to prove how you were overcharged so have some evidence handy.",
    callPaymentText3: 'Call us on ',
    callPaymentText4: '0800 121 4254',
    callPaymentText5:
      ", We're available Monday to Friday, 8am to 7pm, and Saturday, 9am to 5pm. Calls are free from UK landlines and personal mobiles.",
    thirtyDayPaymentTitle: "You can't dispute this payment yet",
    thirtyDayPaymentText1:
      'It needs to be at least 30 days since the payment was made.',
    disputePaymentTitle: 'Getting started',
    disputePaymentText1:
      'To help you try to get your money back, we need to ask you some questions about your dispute. It should only take a few minutes.',
    disputePaymentSubTitle: "What's gone wrong?",
    disputePaymentOption1:
      "You haven't received your goods or services (including flights or holidays)",
    disputePaymentOption2:
      'You have been charged more than once or charged the wrong amount',
    disputePaymentOption3:
      'You received an item that was damaged, fake or not as described',
    disputePaymentOption4:
      "You haven't receieved a refund, credit or replacement",
    contactSellerTitle: 'Have you contacted the seller?',
    contactSellerText1:
      "Before you dispute a payment, you'll need to try and get things resolved with the seller.",
    contactSellerText2:
      "If you've contacted them, we'll ask for more information on what happened.",
    // Beneficiary copy
    benSyncLandingHeader: 'Transfer your payees',
    benSyncLandingSubHeader1:
      'It’s time to transfer your payees from our old internet banking service. Simply choose what payees to bring across and they’ll be available on internet banking and our mobile app.',
    benSyncLandingSubHeader2:
      'Please note that any payees you transfer over will be visible to other account holders on your joint account.',
    benSyncPickPayee: 'Select payees',
    benSyncPayeeFound: 'payee found',
    benSyncPayeesFound: 'payees found',
    benSyncColumnHeaderName: 'Payee name',
    benSyncColumnHeaderNickname: 'Nickname',
    benSyncColumnHeaderAccNo: 'Sort code and account number',
    benSyncColumnHeaderReference: 'Reference',
    benSyncFooterMessage:
      'That’s them all. Only payees that you’ve paid in the last 12 months are available to transfer.',
    benSyncButton: 'Transfer payees now',
    benSyncNoPayeeSelected:
      'Validation message if the customer doesn’t select any payees: Oops, you’ll have to pick at least one payee to continue.',
    benSyncCancelPopupHeader: 'Are you sure you want to cancel?',
    benSyncCancelPopupBody:
      'If you cancel now, none of your payees will be transferred across from our old internet banking service.',
    benSyncPopupYesButton: 'Yes, cancel',
    benSyncPopupNoButton: "No, don't cancel",
    benSyncSuccesHeader: 'Payees transferred',
    benSyncSuccesBody:
      'Your payees have been successfully transferred across from our old internet banking service.',
    benSyncNoPayeeHeader: 'No payees to transfer',
    benSyncNoPayeeBody:
      'You don’t have any payees to transfer across from our old internet banking service. Only payees that you’ve paid in the last 12 months are available to transfer.',
    benSyncCalloutBody:
      "You can now transfer your payees from our old internet banking service. Simply choose what payees to bring across and they'll be available on internet banking and our mobile app.",
    benSyncCalloutBody1:
      'Please note that any payees you transfer over will be visible to other account holders on your joint account.',
    benSyncCalloutHeader: 'Transfer your payees',
    benSyncCalloutButton: 'OK, get started',
    benSyncChooseAccountHeader: 'Choose what account to link these payees to',
    benSyncChooseAccountBody:
      "You'll still be able to move money to these payees from your other accounts.",
    benSyncChooseAccountInlineError: 'Please choose an account to continue.',
    selectAll: 'Select All',

    // SME Payment History
    smePaymentHistoryTitle: 'Payment status and history',
    smePaymentHistoryIntroduction:
      'Keep track of the payments and transfers you’ve made from internet banking or your mobile banking app.',

    // Paperless Preferences
    paperlessReasonsTitle: 'Going digital with letters and statements',
    paperlessReason1:
      'Easy to find, view and download - no more searching through your cupboards or drawers to find your documents',
    paperlessReason2:
      'Reduces your filing, shredding or recycling chores - reducing paper waste',
    paperlessReason3:
      'Securely stored and available online 24/7 within internet banking and the mobile app - no need to wait for the post',
    paperlessReason4:
      'Change your preferences at any time or get in touch if you need a paper copy',
    paperlessReason5:
      'Email alerts let you know when a new digital statement or document is available.',
    preferencesUpdatedBody:
      'If a document has just been issued it may be the following month before your updated preferences take effect.',
    preferencesUpdatedTitle: 'Your preferences have been updated',
    paperlessInfoTitle: 'Important information',
    paperlessInfoBody1:
      'By tapping the button below, you are agreeing to receive communications from the Bank digitally, including statements. We’ll send you an email whenever a new document is available so it is important to keep your contact details up-to-date. All digital communications will be available to view, print or download from within internet banking and the mobile app. We may continue to send you some statements or documents by post. If you currently receive communications from us in Braille, large text or audio these will stop, however you can change your preferences at any time.',
    paperlessInfoBody2:
      'For joint account holders, you are choosing this option for both of you - so it’s worth checking that the other account holder is happy with this first.',
    preferencesUpdateErrorTitle: 'Sorry, something has gone wrong.',
    preferencesUpdateErrorBody1:
      'Your paper-free preferences have not been updated.',
    preferencesUpdateErrorBody2: 'Please try again later.',
    preferencesAcceptClick: 'Make me paper-free where possible',
    preferencesManageClick: 'Let me choose my paper-free accounts',

    preferencesPopupWarningHeaderAuto: 'You haven’t confirmed your changes yet',
    preferencesPopupWarningHeaderManage:
      'You haven’t confirmed your preferences',
    preferencesPopupWarningBodyAuto:
      'Please, review and confirm your preferences before moving on.',
    preferencesPopupWarningBodyManage:
      'You’ve changed your paper-free preferences but haven’t confirmed them yet',
    preferencesContinuePageBtn: 'Review and confirm changes',
    preferencesLeavePageBtn: 'Discard changes',

    accountStatusHeaderContent: "Can't load account details",
    accountStatusBodyContent:
      "Sorry, it looks like there's been a technical problem while loading your account details. Please try again.",
    // otp
    authorisationFailedHeader: 'Authorisation failed',
    authorisationFailedBody:
      'Sorry, the details you’ve entered haven’t been recognised, so for security reasons, we’ve logged you out of internet banking. To continue with your payment, you’ll have to log back in and start again.',

    beneficiaryFailedHeader: 'Check your payee list',
    beneficiaryFailedBody:
      "Sorry, it looks like there may have been a technical problem while adding your payee. Before you try and add them again, check your payee list to see if they've been successfully added.",
    //Account picker (Large Customer View)
    accountPickerModalTitle: 'You’ve added all your favourites',
    accountPickerModalContent:
      'You can only set up to 30 favourite accounts. If you’d still like to add this account as a favourite, you can unselect another account by clicking or tapping the star.',
    accountPickerPaymentsChoose:
      'Choose an account to view it’s payment status and history.',
    accountPickerManagePaymentsChoose:
      'Choose an account to view any scheduled payments.',
    accountPickerPageTitle: 'Account',
    accountPickerPageBack: 'Back',
    accountPickerLauncherButton: 'Choose account',
    accountPickerTitle: 'Account',
    accountPickerSelectedButton: 'Change account',
    accountDropDownTitle: 'Account',
    manageAccountPools: {
      accountPoolsTitle: 'Account pools',
      createAccountPool: 'Create account pool',
      noAccountPoolExist:
        'There’s nothing to see yet. Create an account pool if you want to see the combined balances and transactions of more than one business account at a glance.',
      createFirstAccountPool: 'Create first account pool',
      accountPoolHeading: 'View the account pool to make any changes.',
    },
    //Create Account Pool
    yourAccountType: {
      fieldHeader: 'Notional Currency',
      fieldOptions: [
        {
          value: 'GBP',
          label: 'GBP Pound Sterling',
        },
        {
          value: 'EUR',
          label: 'EUR Euro',
        },
        {
          value: 'USD',
          label: 'USD US Dollar',
        },
        {
          value: 'other',
          label: 'Other',
        },
      ],
    },
    createPoolButtonText: 'Create Pool',
    savePoolButtonText: 'Save Pool',
    subHeadingCreatePool: 'Select account to add to this pool.',
    subHeadingUpdatePool: 'Select account to add or remove from this pool.',
    subSectionHeading: 'Choose two or more to save.',
    accountsSelected: 'accounts selected ',
    createAccountPool: 'Create Account Pool',
    editAccountPool: 'Edit Account Pool',
    nameofPool: 'Name for this pool of accounts',
    deletePool: 'Delete Pool',
    selectAccountCreateMsg: 'Select accounts to add to this pool',
    selectAccountEditMsg: 'Select account to add or remove from this pool',
    selectAccount: 'Select account to add to this pool',
    chooseAccountValidationMessage: 'Choose two or more to save.',
    deletePoolModalTitle: 'Sure you want to delete this pool?',
    deletePoolModalBody:
      'You’ll still be able to view accounts in this pool individually.',
    dismissDeleteAccountPoolButton: 'No, keep pool',
    confirmDeleteAccountPoolButton: 'Yes, delete pool',
    createAnotherPoolButton: 'Create Another Pool',
    editPoolButton: 'Edit Pool',
    deletePoolButton: 'Delete Pool',
    viewPoolScreenTitle: 'Account pool details',
    poolDetailPanelText:
      'Available balances include pending transactions, so it shows what’s available right now',
    errorMessages: {
      poolNameEmptyErrorMessage:
        "Hmm, looks like we're missing something. Can you pick a name for this account pool using only letters, numbers, spaces and simple characters like hyphens or full stops?",
      poolNameInvalidErrorMessage:
        "Ah, that didn't work. Can you try again by picking a pool name using only letters, numbers, spaces and simple characters like hyphens or full stops?",
      popularNotionalCurrencyMessage: 'Please select currency',
      notionalCurrencyMessage: 'Please select currency',
    },

    currencies: [
      { id: 'CZK', label: 'Czech Koruna', shortCode: 'CZK' },
      { id: 'NZD', label: 'New Zealand Dollar', shortCode: 'NZD' },
      { id: 'SAR', label: 'Saudi Riyal', shortCode: 'SAR' },
      { id: 'PLN', label: 'Polish Zloty', shortCode: 'PLN' },
      { id: 'THB', label: 'Thai Baht', shortCode: 'THB' },
      { id: 'INR', label: 'Indian Rupees', shortCode: 'INR' },
      { id: 'DEM', label: 'German Mark', shortCode: 'DEM' },
      { id: 'CHF', label: 'Swiss franc', shortCode: 'CHF' },
      { id: 'FRF', label: 'French franc', shortCode: 'FRF' },
      { id: 'SEK', label: 'Swedish Krona', shortCode: 'SEK' },
      { id: 'DKK', label: 'Danish Krone', shortCode: 'DKK' },
      { id: 'ITL', label: 'Italian Lira', shortCode: 'ITL' },
      { id: 'NOK', label: 'Norwegian krone', shortCode: 'NOK' },
      { id: 'BEF', label: 'Belgian Franc', shortCode: 'BEF' },
      { id: 'CAD', label: 'Canadian Dollar', shortCode: 'CAD' },
      { id: 'AUD', label: 'Australian Dollar', shortCode: 'AUD' },
      { id: 'HKD', label: 'Hong Kong Dollar', shortCode: 'HKD' },
      { id: 'SGD', label: 'Singapore Dollar', shortCode: 'SGD' },
      { id: 'ATS', label: 'Austrian shilling', shortCode: 'ATS' },
      { id: 'ZAR', label: 'South African rand', shortCode: 'ZAR' },
      { id: 'AED', label: 'United Arab Emirates Dirham', shortCode: 'AED' },
      { id: 'MYR', label: 'Malaysian Ringgit', shortCode: 'MYR' },
      { id: 'JPY', label: 'Japanese Yen', shortCode: 'JPY' },
      { id: 'NLG', label: 'Dutch Guilders', shortCode: 'NLG' },
      { id: 'IRP', label: 'Irish Punt', shortCode: 'IRP' },
    ],
    popularCurrencies: ['GBP', 'EUR', 'USD'],
    confirmationOfPayeeContent: {
      noPreviousCheckHeader: 'Name not checked',
      noPreviousCheckDescription:
        "We've not checked this account with the name-matching service before. For added security, please review their details before continuing.",
      noPreviousCheckButton: 'Check now',
    },
  };

  // Address validations. There is a max of 15 so create 15 of these.
  for (var i = 0; i < 15; i++) {
    result['addressPrefix_' + i + 'ValidationMessage'] =
      'Sorry, your flat number must be written using numbers and letters only and no longer than 40 characters.';
    result['addressPrefix_' + i + 'HelpMessage'] =
      'This is the flat number of your house or apartment.';
    result['houseNumber_' + i + 'ValidationMessage'] =
      'Sorry, your house number must be written using numbers and letters only and no longer than 40 characters.';
    result['houseNumber_' + i + 'HelpMessage'] =
      'This is the number of your house or apartment.';
    result['houseName_' + i + 'ValidationMessage'] =
      'Sorry, your house name must be written using numbers and letters only.';
    result['houseName_' + i + 'HelpMessage'] =
      'This is the name of your house or apartment.';
    result['streetName_' + i + 'ValidationMessage'] =
      'Your street name should be written using numbers and letters only and be no longer than 40 characters.';
    result['streetName_' + i + 'HelpMessage'] =
      'Your street name should be written using number and letters only.';

    for (var j = 1; j < 5; j++) {
      result[['addressLine', j, '_', i, 'ValidationMessage'].join('')] =
        'Your address line ' +
        j +
        ' should be written using numbers and letters only and be no longer than 40 characters.';
      result[['addressLine', j, '_', i, 'HelpMessage'].join('')] =
        'Your address line ' +
        j +
        ' should be written using number and letters only.';
    }

    result['city_' + i + 'ValidationMessage'] =
      'Your town should be written using numbers and letters only and no longer than 40 characters.';
    result['city_' + i + 'HelpMessage'] =
      'Please tell us which town or city this address is in.';
    result['county_' + i + 'ValidationMessage'] =
      'Your county should be written using numbers and letters only and no longer than 40 characters.';
    result['county_' + i + 'HelpMessage'] =
      'Please tell us which county this address is in.';
    result['country_' + i + 'ValidationMessage'] =
      'Please select a valid option from the dropdown.';
    result['country_' + i + 'HelpMessage'] =
      'Your current address must be in the UK, but for previous addresses, please tell us which country you lived in.';
    result['dateMoved_' + i + 'ValidationMessage'] =
      "For current addresses, the date you moved in needs to be before today. If it's a previous address, it should be an earlier date than any addresses listed above it.";
    result['dateMoved_' + i + 'HelpMessage'] =
      'Please enter the day month and year you moved to this address.';
    result['postcode_' + i + 'ValidationMessage'] =
      "Please check as this postcode can't be found. Postcodes are normally formatted like this - A12 3BC - if yours still can't be found please call the team at B on " +
      brand.phoneNumber +
      '.';
    result['postcode_' + i + 'HelpMessage'] =
      'You need to supply a valid postcode for any UK address you add. These are normally formatted like this: A12 3BC. If you live at a BFPO address, please call us.';
  }

  return Object.freeze(result);
};
